import { formatDate } from '@angular/common';
import { HttpParams } from '@angular/common/http';
import { Component, ElementRef, HostListener, Inject, OnDestroy, OnInit, Optional, ViewChild } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '../../../../../../projects/kiene-core/src/lib/components/dialogs/confirm-dialog/confirm-dialog.component';
import { ConfirmDialogInput, ConfirmDialogResult } from '../../../../../../projects/kiene-core/src/lib/components/dialogs/confirm-dialog/confirm-dialog';
import { Router } from '@angular/router';
import { of, Subscription, Observable } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { Client } from '../../../../../../projects/kiene-core/src/lib/components/client/classes/client';
import { BenutzerBetriebskontakteTierlisteService } from '../../../../../../projects/kiene-core/src/lib/services/backend-api/benutzer-betriebskontakte-tierliste.service';
import { Betriebskontakt } from '../../../../../../projects/kiene-core/src/lib/components/stammdaten/betriebskontakte/betriebskontakt';
import { ClientService } from '../../../../../../projects/kiene-core/src/lib/components/client/client.service';
import {
    AusstallenEmpfaengerDialogComponent,
    AusstallenEmpfaengerDialogResult,
} from '../../../../../../projects/kiene-core/src/lib/components/ausstallen/ausstallen-empfaenger-dialog/ausstallen-empfaenger-dialog.component';
import { Gruppe } from '../../../../../../projects/kiene-core/src/lib/components/gruppen/classes/gruppe';
import { GruppeStandort } from '../../../../../../projects/kiene-core/src/lib/components/gruppen/gruppe-standort-verwalten/gruppe-standort';
import {
    ohneTierlisteKommentar,
    Tierliste,
} from '../../../../../../projects/kiene-core/src/lib/components/gruppe-tier/classes/tierliste';
import { GruppeTierBulkOverwriteDialogComponent } from '../../../../../../projects/kiene-core/src/lib/components/gruppe-tier/gruppe-tier-bulk-overwrite-dialog/gruppe-tier-bulk-overwrite-dialog.component';
import {
    BulkOverwriteAnimalRow,
    BulkOverwriteFieldKey,
    BulkOverwriteFieldSpec,
    BulkOverwriteMode,
    mapGruppeTierRecordToBulkRow,
    needsBulkOverwriteConfirm,
    resolveBulkPerTierValue,
} from '../../../../../../projects/kiene-core/src/lib/components/gruppe-tier/gruppe-tier-bulk-overwrite-dialog/gruppe-tier-bulk-overwrite-dialog';
import { GruppeTierJeTierNachtragenDialogComponent } from '../../../../../../projects/kiene-core/src/lib/components/gruppe-tier/gruppe-tier-je-tier-nachtragen-dialog/gruppe-tier-je-tier-nachtragen-dialog.component';
import {
    JeTierNachtragenField,
} from '../../../../../../projects/kiene-core/src/lib/components/gruppe-tier/gruppe-tier-je-tier-nachtragen-dialog/gruppe-tier-je-tier-nachtragen-dialog';
import {
    LISTE_ABSCHLIESSEN_STEPPER_HANDLER,
    ListeAbschliessenStepperHandler,
} from '../../../../../../projects/kiene-core/src/lib/components/gruppen/gruppe-abgang/liste-abschliessen-stepper.handler';
import { GruppeAbgangService } from '../../../../../../projects/kiene-core/src/lib/components/gruppen/gruppe-abgang/gruppe-abgang.service';
import {
    getTierlisteZielbetriebAnzeigeName,
    ExternEmpfaengerDisplayEntry,
    getExternEmpfaengerDisplayEntries,
    getExternEmpfaengerDisplayLines,
    hasExternEmpfaenger,
    applyExternEmpfaengerPersistFields,
    applySchlachthofPersistField,
    mapBetriebskontakteTierlisteVerbindungenToKontakte,
    patchTierlisteFromExternEmpfaenger,
    filterAktiveBetriebskontakteTierlisteVerbindungen,
    unwrapBetriebskontakteTierlisteReadResponse,
} from '../../../../../../projects/kiene-core/src/lib/components/gruppe-tier/tierliste-zielbetrieb-display.util';
import { ImportOptionenDialogComponent } from '../../../../../../projects/kiene-core/src/lib/components/gruppen/import-optionen-dialog/import-optionen-dialog.component';
import { API_BASE_URL_SERVICE } from '../../../../../../projects/kiene-core/src/lib/kiene-core.config';
import { AppService } from '../../../../../../projects/kiene-core/src/lib/services/app/app.service';
import { KieneBackendApiService } from '../../../../../../projects/kiene-core/src/lib/services/backend-api/kiene-backend-api.service';
import { LocalStorageService } from '../../../../../../projects/kiene-core/src/lib/services/local-storage/local-storage.service';
import { MessageService } from '../../../../../../projects/kiene-core/src/lib/services/message-service/message.service';
import { LetzteAktionenTierlisteMenuCacheService } from '../letzte-aktionen-tierliste-menu-cache.service';
import { GruppenDashboardImportRefreshService } from '../../gruppen-dashboard-import-refresh.service';
import { ChangeCurrentClientService } from '../../../../administration/client/change-current-client/change-current-client.service';
import { GruppeAuswaehlenDialogComponent } from '../../../tierlisten/aktuelle-tierlisten/gruppe-auswaehlen-dialog/gruppe-auswaehlen-dialog.component';
import { GruppeAuswaehlenDialogInput2 } from '../../../tierlisten/aktuelle-tierlisten/gruppe-auswaehlen-dialog/gruppe-auswaehlen-dialog';
import { getGruppeAuswaehlenDialogShellConfig } from '../../../../../../projects/kiene-core/src/lib/components/gruppen/gruppe-auswaehlen-dialog/gruppe-auswaehlen-dialog';
import {
    getGruppeLinksForRow,
    getLetzteAktionenDisplayedChipClass,
    getLetzteAktionenDisplayedStatusLabel,
    formatLetzteAktionPreisGesamt,
    canShowAusstallenErloesTageszunahmen,
    getLetzteAktionenStatusPhase,
    getLetzteAktionGewichtGesamt,
    getLetzteAktionGewichtProTier,
    getLetzteAktionPreisGesamt,
    getLetzteAktionPreisProTier,
    formatLetzteAktionGewichtGesamt,
    formatLetzteAktionGewichtProTier,
    formatLetzteAktionPreisProTier,
    canEditDirectScanEinstallGewichtPreis,
    canEditImportedEinstallGewichtPreis,
    getEinstallTierlisteIdForRow,
    isImportedEinstallAbgeschlossen,
    isImportedTierlisteEinstallen,
    canEditHerkunftForLetzteAktionRow,
    isPendingImportEinstallRow,
    shouldShowGewichtPreisMetricsForLetzteAktionRow,
    shouldShowAbschnittForLetzteAktionRow,
    getLetzteAktionAbschnittDisplay,
    getLetzteAktionHerkunftZielDisplay,
    shouldShowAktuelleGruppeForRow,
    getAusstallTierlisteIdForImportRow,
    resolveAusstallTierlisteIdForHerkunft,
    isDirectScanEinstallTierliste,
    isImportEinstallTierliste,
    canContinueDirectScanEinstall,
    getLetzteAktionEinstallDatumYmd,
    parseWertAnzahl,
    getTierLetzteAktionDisplayLabel,
    isGlobalAusstallTierliste,
    isLetzteAktionImportPrioritaet,
    LetzteAktionWertAnzahl,
    TierLetzteAktionGruppeLink,
    TierLetzteAktionRow,
    TierLetzteAktionTyp,
} from '../letzte-aktionen.models';
import { DashboardEinstallenStepperDialogComponent } from '../../dashboard-einstallen-stepper-dialog/dashboard-einstallen-stepper-dialog.component';
import {
    DashboardEinstallenStepperDialogData,
    dashboardEinstallenStepperDialogLayout,
} from '../../dashboard-einstallen-stepper-dialog/dashboard-einstallen-stepper-dialog.data';
import { GruppeTier } from '../../../../../../projects/kiene-core/src/lib/components/gruppe-tier/classes/gruppe-tier';
import { DashboardTierlisteHerkunftSetzenDialogComponent, DashboardTierlisteHerkunftSetzenDialogResult } from '../dashboard-tierliste-herkunft-setzen-dialog/dashboard-tierliste-herkunft-setzen-dialog.component';
import {
    GruppeAendernDashboardSync,
    GruppeTierService,
} from '../../../../../../projects/kiene-core/src/lib/components/gruppe-tier/gruppe-tier.service';
import {
    LetzteAktionenTiereDialogComponent,
    LetzteAktionTierListItem,
} from '../letzte-aktionen-tiere-dialog/letzte-aktionen-tiere-dialog.component';

const PERMISSION_GEWICHTE = 9161;
const PERMISSION_PREISE = 9162;
const PERMISSION_IMPORTIEREN = 9322;
const PERMISSION_HERKUNFT = 11014;
const PERMISSION_GRUPPE_AENDERN = 9122;

export interface LetzteAktionenDetailDialogData {
    row: TierLetzteAktionRow;
    /** Opened from /gruppen/tierlisten — show Kommentar + editable Ausstalldatum. */
    tierlisteKontext?: boolean;
    /** Reload Letzte Aktionen list after row metadata changed (e.g. Gruppe ändern). */
    onRowChanged?: (options?: { reload?: boolean }) => void;
}

/** Which Gewichte & Preise block to highlight when a metric card is activated. */
export type LetzteAktionenMetricEditFocus =
    | 'einstall-preis'
    | 'einstall-gewicht'
    | 'abgang-preis'
    | 'abgang-gewicht';

export type LetzteAktionenMetricEntryMode = 'gesamt' | 'proTier';

@Component({
    selector: 'kiene-letzte-aktionen-detail-dialog',
    templateUrl: './letzte-aktionen-detail-dialog.component.html',
    styleUrls: ['./letzte-aktionen-detail-dialog.component.scss'],
})
export class LetzteAktionenDetailDialogComponent implements OnInit, OnDestroy {
    readonly einstallenAktion = TierLetzteAktionTyp.einstallen;
    readonly ausstallenAktion = TierLetzteAktionTyp.ausstallen;

    isLoading = true;
    isSaving = false;
    loadError: string | null = null;

    gruppeStandort: GruppeStandort | null = null;
    /** kunde_id of the loaded source gruppe (for API mandant resolution). */
    private gruppeKundeId: number | null = null;
    tierliste: Tierliste | null = null;
    anzahlTiere = 0;
    /** Child Einstall-liste after Umstallen import (animals leave Ausstall-liste on gt). */
    private linkedEinstallTierlisteId: number | null = null;
    gruppeLinks: TierLetzteAktionGruppeLink[] = [];

    tiereList: LetzteAktionTierListItem[] = [];
    tiereLoading = false;

    zielbetrieb: Client | null = null;
    schlachthof: Client | null = null;
    empfaengerKontakte: Betriebskontakt[] = [];
    /** Cached for template binding; avoids *ngFor re-creating nodes every change detection. */
    zielbetriebDisplayEntries: ExternEmpfaengerDisplayEntry[] = [];
    private initialZielKundeId: number | null = null;
    private initialSchlachthofKundeId: number | null = null;
    private initialKontaktIds: number[] = [];
    private initialKundeIdEinstallen: number | null = null;
    private initialKundeIdZielbetrieb: number | null = null;
    /** Snapshot of persisted metric fields; used to detect unsaved weight/price edits on close. */
    private initialMetricSaveFingerprint = '{}';
    /** Form + row metric values after last successful load/save – restored if overwrite dialog is cancelled. */
    private initialMetricGesamtSnapshot: {
        einkaufPreis: number | null;
        verkaufPreis: number | null;
        einstallGewicht: number | null;
        abgangGewicht: number | null;
        einkaufMwst: number;
        verkaufMwst: number;
    } | null = null;
    private initialRowMetricsSnapshot: {
        einkaufspreis_avg: LetzteAktionWertAnzahl | null;
        verkaufspreis_avg: LetzteAktionWertAnzahl | null;
        einstallgewicht_avg: LetzteAktionWertAnzahl | null;
        abgangsgewicht_avg: LetzteAktionWertAnzahl | null;
    } | null = null;

    /** Gesamtwerte (API speichert pro Tier = gesamt ÷ Anzahl Tiere). */
    einkaufPreisCtrl = new FormControl<number | null>(null, [Validators.min(0.01)]);
    verkaufPreisCtrl = new FormControl<number | null>(null, [Validators.min(0.01)]);
    einstallGewichtCtrl = new FormControl<number | null>(null, [Validators.min(0.01)]);
    abgangGewichtCtrl = new FormControl<number | null>(null, [Validators.min(0.01)]);
    einkaufPreisProTierCtrl = new FormControl<number | null>(null, [Validators.min(0.01)]);
    verkaufPreisProTierCtrl = new FormControl<number | null>(null, [Validators.min(0.01)]);
    einstallGewichtProTierCtrl = new FormControl<number | null>(null, [Validators.min(0.01)]);
    abgangGewichtProTierCtrl = new FormControl<number | null>(null, [Validators.min(0.01)]);
    einkaufMwstCtrl = new FormControl<number>(7, [Validators.required]);
    verkaufMwstCtrl = new FormControl<number>(7, [Validators.required]);

    /** Per-card entry mode (gesamt vs pro Tier); defaults to gesamt. */
    private readonly metricEntryMode: Partial<Record<LetzteAktionenMetricEditFocus, LetzteAktionenMetricEntryMode>> =
        {};

    /** Metric card currently in edit mode (single active card). */
    editingMetric: LetzteAktionenMetricEditFocus | null = null;

    kommentarCtrl = new FormControl<string>('');
    datumCtrl = new FormControl<Date | null>(null);
    isKommentarEditing = false;
    isDatumEditing = false;
    @ViewChild('kommentarInput') private kommentarInput?: ElementRef<HTMLInputElement>;
    @ViewChild('tierlisteDatumInput') private tierlisteDatumInput?: ElementRef<HTMLInputElement>;
    private initialTierlisteMetaFingerprint = '';

    /** Set before bulk weight/price POST (from overwrite confirm dialog). */
    private pendingOverwriteMode: BulkOverwriteMode = 'empty_only';
    private pendingOverwriteAnimals: BulkOverwriteAnimalRow[] = [];
    private pendingOverwriteFields: BulkOverwriteFieldSpec[] = [];

    private readonly subscriptions = new Subscription();

    constructor(
        @Inject(MAT_DIALOG_DATA) public readonly data: LetzteAktionenDetailDialogData,
        public readonly dialogRef: MatDialogRef<LetzteAktionenDetailDialogComponent>,
        @Inject(API_BASE_URL_SERVICE) private readonly apiBaseUrl: string,
        private readonly api: KieneBackendApiService,
        private readonly messageService: MessageService,
        private readonly localStorageService: LocalStorageService,
        private readonly tierlisteCache: LetzteAktionenTierlisteMenuCacheService,
        private readonly dialog: MatDialog,
        private readonly appService: AppService,
        private readonly bbtService: BenutzerBetriebskontakteTierlisteService,
        private readonly clientService: ClientService,
        private readonly changeCurrentClientService: ChangeCurrentClientService,
        private readonly abgangService: GruppeAbgangService,
        private readonly gruppeTierService: GruppeTierService,
        private readonly gruppenDashboardImportRefresh: GruppenDashboardImportRefreshService,
        private readonly router: Router,
        @Optional()
        @Inject(LISTE_ABSCHLIESSEN_STEPPER_HANDLER)
        private readonly listeAbschliessenStepperHandler?: ListeAbschliessenStepperHandler,
    ) {}

    get isInternTransfer(): boolean {
        if (this.tierliste) {
            return Number(this.tierliste.umstallen) === 1;
        }
        return this.row.umstallen === true;
    }

    get zielCardActionHint(): string {
        return this.isInternTransfer ? 'Bearbeiten' : 'Kontakt oder Schlachthof wählen';
    }

    get zielCardAriaLabel(): string {
        return this.isInternTransfer
            ? 'Zielbetrieb auswählen'
            : 'Empfänger auswählen: Kontakt oder Schlachthof';
    }

    get row(): TierLetzteAktionRow {
        return this.data.row;
    }

    get isEinstallen(): boolean {
        return this.row.aktion === this.einstallenAktion;
    }

    get isAusstallen(): boolean {
        return this.row.aktion === this.ausstallenAktion;
    }

    /** Hidden while Ausstallen is open (no kp_abgangsdatum → no metrics from API). */
    get showAusstallenErloesTageszunahmen(): boolean {
        return canShowAusstallenErloesTageszunahmen(this.row);
    }

    get canShowPreis(): boolean {
        if (this.data.tierlisteKontext && !this.isTierlisteErstelltMetricsContext()) {
            return false;
        }
        return (
            this.localStorageService.hasPermission(PERMISSION_PREISE) &&
            this.localStorageService.isRecordModulAllowed(this.row, 'bio') &&
            shouldShowGewichtPreisMetricsForLetzteAktionRow(this.row, this.tierliste)
        );
    }

    get canShowGewicht(): boolean {
        if (this.data.tierlisteKontext && !this.isTierlisteErstelltMetricsContext()) {
            return false;
        }
        return (
            this.localStorageService.hasPermission(PERMISSION_GEWICHTE) &&
            this.localStorageService.isRecordModulAllowed(this.row, 'bio') &&
            shouldShowGewichtPreisMetricsForLetzteAktionRow(this.row, this.tierliste)
        );
    }

    get canEditZielbetrieb(): boolean {
        return (
            this.isAusstallen &&
            this.row.tierliste_id != null &&
            this.row.tierliste_id > 0 &&
            getLetzteAktionenStatusPhase(this.row) === 'erstellt'
        );
    }

    get showTierlisteMetaFields(): boolean {
        return this.isAusstallen && !!this.row.tierliste_id;
    }

    get canEditTierlisteMeta(): boolean {
        return this.showTierlisteMetaFields && getLetzteAktionenStatusPhase(this.row) === 'erstellt';
    }

    get canEditGewichtPreis(): boolean {
        if (this.data.tierlisteKontext) {
            if (!this.isTierlisteErstelltMetricsContext() || !this.tierliste?.tierliste_id) {
                return false;
            }
            if (!this.gruppeStandort?.gs_id) {
                return false;
            }
            return (
                this.localStorageService.hasPermission(PERMISSION_PREISE) ||
                this.localStorageService.hasPermission(PERMISSION_GEWICHTE)
            );
        }
        if (!this.gruppeStandort?.gs_id) {
            return false;
        }
        if (this.isAusstallen) {
            return !!(this.row.tierliste_id && this.tierliste?.tierliste_id);
        }
        if (this.isEinstallen) {
            if (isDirectScanEinstallTierliste(this.row, this.tierliste)) {
                return (
                    canEditDirectScanEinstallGewichtPreis(this.row, this.tierliste) &&
                    !!this.gruppeStandort?.gs_id
                );
            }
            if (isImportEinstallTierliste(this.row, this.tierliste)) {
                return (
                    !!(this.tierliste?.tierliste_id) &&
                    canEditImportedEinstallGewichtPreis(this.row, this.tierliste)
                );
            }
        }
        return false;
    }

    get canShowScansFortsetzenButton(): boolean {
        if (!this.isAusstallen || !this.row.tierliste_id || this.row.tierliste_id <= 0) {
            return false;
        }
        if (isLetzteAktionImportPrioritaet(this.row)) {
            return false;
        }
        return getLetzteAktionenStatusPhase(this.row) === 'erstellt';
    }

    get canShowListeAbschliessenButton(): boolean {
        return this.canShowScansFortsetzenButton || this.canShowContinueScansButton;
    }

    get canShowAnyScansFortsetzenButton(): boolean {
        return this.canShowContinueScansButton || this.canShowScansFortsetzenButton;
    }

    get canShowImportierenButton(): boolean {
        if (!this.localStorageService.hasPermission(PERMISSION_IMPORTIEREN)) {
            return false;
        }
        if (!this.row.tierliste_id || this.row.tierliste_id <= 0) {
            return false;
        }
        if (this.isImportClosedForRow) {
            return false;
        }
        if (isLetzteAktionImportPrioritaet(this.row)) {
            return true;
        }
        if (isDirectScanEinstallTierliste(this.row, this.tierliste)) {
            return false;
        }
        return this.isEinstallen && getLetzteAktionenStatusPhase(this.row) === 'erstellt';
    }

    get canShowContinueScansButton(): boolean {
        return canContinueDirectScanEinstall(this.row, this.tierliste);
    }

    get isImportClosedForRow(): boolean {
        if (isDirectScanEinstallTierliste(this.row, this.tierliste)) {
            return false;
        }
        if (!isImportEinstallTierliste(this.row, this.tierliste)) {
            return false;
        }
        return this.row.import_einstallen === false && !!this.row.tierliste_id;
    }

    get showImportClosedHint(): boolean {
        return this.isEinstallen && getLetzteAktionenStatusPhase(this.row) === 'erstellt' && this.isImportClosedForRow;
    }

    canEditMetric(focus: LetzteAktionenMetricEditFocus): boolean {
        if (!this.canEditGewichtPreis) {
            return false;
        }
        if (focus === 'einstall-preis' || focus === 'abgang-preis') {
            return this.canShowPreis;
        }
        return this.canShowGewicht;
    }

    isMetricEditing(focus: LetzteAktionenMetricEditFocus): boolean {
        return this.editingMetric === focus;
    }

    metricInputId(focus: LetzteAktionenMetricEditFocus): string {
        const mode = this.getMetricEntryMode(focus);
        return `la-metric-input-${focus}-${mode}`;
    }

    getMetricEntryMode(focus: LetzteAktionenMetricEditFocus): LetzteAktionenMetricEntryMode {
        return this.metricEntryMode[focus] ?? 'gesamt';
    }

    canUseProTierMetricEntry(): boolean {
        return this.effectiveAnzahlTiere() > 0;
    }

    metricTiereLabel(): string {
        const n = this.effectiveAnzahlTiere();
        if (n <= 0) {
            return '';
        }
        return n === 1 ? '1 Tier' : `${n} Tiere`;
    }

    isMetricPrice(focus: LetzteAktionenMetricEditFocus): boolean {
        return focus === 'einstall-preis' || focus === 'abgang-preis';
    }

    isMetricWeight(focus: LetzteAktionenMetricEditFocus): boolean {
        return focus === 'einstall-gewicht' || focus === 'abgang-gewicht';
    }

    openJeTierNachtragen(focus: LetzteAktionenMetricEditFocus, event?: Event): void {
        event?.stopPropagation();
        if (!this.isMetricWeight(focus) || !this.canEditMetric(focus)) {
            return;
        }
        const field: JeTierNachtragenField =
            focus === 'abgang-gewicht' ? 'abgangsgewicht' : 'einstallgewicht';
        const title =
            focus === 'abgang-gewicht' ? 'Abgangsgewicht je Tier' : 'Einstallgewicht je Tier';
        const gruppeId = Number(this.gruppeStandort?.gruppe_id) || Number(this.row.gruppe_id) || 0;
        if (gruppeId <= 0) {
            this.messageService.alertMessage('Gruppe konnte nicht ermittelt werden.');
            return;
        }

        void this.loadAnimalsWithGtIds()
            .then(withIds => {
                if (!withIds.length) {
                    this.messageService.alertMessage('Keine Tiere auf der Liste.');
                    return;
                }
                this.dialog
                    .open(GruppeTierJeTierNachtragenDialogComponent, {
                        width: '560px',
                        maxWidth: '95vw',
                        disableClose: true,
                        data: {
                            title,
                            field,
                            unit: 'kg',
                            gruppeId,
                            gsId: this.gruppeStandort?.gs_id ?? null,
                            animals: withIds.map(r => ({
                                gt_id: r.gt_id,
                                ohrmarke: r.ohrmarke,
                                value:
                                    field === 'abgangsgewicht' ? r.ausstallgewicht : r.einstallgewicht,
                            })),
                        },
                    })
                    .afterClosed()
                    .subscribe(result => {
                        if (!result?.saved) {
                            return;
                        }
                        this.applyJeTierNachtragenResult(focus, result.gesamt, result.anzahlMitWert);
                    });
            })
            .catch(err => {
                this.messageService.errorMessage('Tiere konnten nicht geladen werden', err);
            });
    }

    private loadAnimalsWithGtIds(): Promise<
        Array<{
            gt_id: number;
            ohrmarke: string;
            einstallgewicht: number | null;
            ausstallgewicht: number | null;
        }>
    > {
        return this.loadAnimalsForBulkOverwriteRaw().then(records =>
            records
                .map(rec => {
                    const mapped = mapGruppeTierRecordToBulkRow(rec);
                    return {
                        gt_id: Number(rec['gt_id']) || 0,
                        ohrmarke: mapped.ohrmarke,
                        einstallgewicht: mapped.einstallgewicht ?? null,
                        ausstallgewicht: mapped.ausstallgewicht ?? null,
                    };
                })
                .filter(r => r.gt_id > 0),
        );
    }

    private loadAnimalsForBulkOverwriteRaw(): Promise<Record<string, unknown>[]> {
        let params: HttpParams | undefined;
        if (this.isAusstallen) {
            const tlId = this.tierliste?.tierliste_id ?? this.row.tierliste_id;
            const gruppeId = this.gruppeStandort?.gruppe_id ?? this.row.gruppe_id;
            if (!tlId || !gruppeId) {
                return Promise.resolve([]);
            }
            params = new HttpParams()
                .set('tierliste_id', String(tlId))
                .set('gruppe_id', String(gruppeId));
        } else {
            const gruppeId = this.gruppeStandort?.gruppe_id ?? this.row.gruppe_id;
            if (!gruppeId) {
                return Promise.resolve([]);
            }
            params = new HttpParams().set('gruppe_id', String(gruppeId));
            const einstallTid = getEinstallTierlisteIdForRow(this.row, this.tierliste);
            if (einstallTid) {
                params = params.set('einstall_tierliste_id', String(einstallTid));
            } else {
                const day = this.getEinstallDatumYmd();
                if (day) {
                    params = params.append('einstalldatum[]', day);
                }
            }
        }
        return new Promise((resolve, reject) => {
            this.api.getAll(this.apiBaseUrl + 'gruppe_tier/read_kundenportal.php', params).subscribe({
                next: response => resolve((response?.records ?? []) as Record<string, unknown>[]),
                error: err => reject(err),
            });
        });
    }

    private applyJeTierNachtragenResult(
        focus: LetzteAktionenMetricEditFocus,
        gesamt: number | null,
        anzahlMitWert: number,
    ): void {
        this.editingMetric = null;
        if (gesamt != null && gesamt > 0 && anzahlMitWert > 0) {
            const metric: LetzteAktionWertAnzahl = { wert: gesamt, anzahl: anzahlMitWert };
            if (focus === 'abgang-gewicht') {
                this.row.abgangsgewicht_avg = metric;
                this.prefillGewichtFromMetric(metric, this.abgangGewichtCtrl);
                this.syncProTierCtrlFromGesamt('abgang-gewicht');
            } else if (focus === 'einstall-gewicht') {
                this.row.einstallgewicht_avg = metric;
                this.prefillGewichtFromMetric(metric, this.einstallGewichtCtrl);
                this.syncProTierCtrlFromGesamt('einstall-gewicht');
            }
        }
        this.captureInitialMetricSaveFingerprint();
        if (this.row.tierliste_id) {
            this.tierlisteCache.invalidate(this.row.tierliste_id);
        }
    }

    setMetricEntryMode(focus: LetzteAktionenMetricEditFocus, mode: LetzteAktionenMetricEntryMode, event?: Event): void {
        event?.stopPropagation();
        if (mode === 'proTier' && !this.canUseProTierMetricEntry()) {
            return;
        }
        const current = this.getMetricEntryMode(focus);
        if (current === mode) {
            return;
        }
        const anzahl = this.effectiveAnzahlTiere();
        const gesamtCtrl = this.getMetricGesamtCtrl(focus);
        const proCtrl = this.getMetricProTierCtrl(focus);
        if (mode === 'proTier' && anzahl > 0) {
            const gesamt = Number(gesamtCtrl.value);
            if (gesamt > 0 && !Number.isNaN(gesamt)) {
                proCtrl.setValue(this.roundProTierFromGesamt(gesamt, anzahl), { emitEvent: false });
            }
        } else if (mode === 'gesamt' && anzahl > 0) {
            const pro = Number(proCtrl.value);
            if (pro > 0 && !Number.isNaN(pro)) {
                gesamtCtrl.setValue(this.roundGesamtFromProTier(pro, anzahl), { emitEvent: false });
            }
        }
        this.metricEntryMode[focus] = mode;
        if (this.editingMetric === focus) {
            this.focusMetricInput(focus);
        }
    }

    getMetricActiveSuffix(focus: LetzteAktionenMetricEditFocus): string {
        const isPrice = this.isMetricPrice(focus);
        if (this.getMetricEntryMode(focus) === 'proTier') {
            return isPrice ? '€ / Tier' : 'kg / Tier';
        }
        return isPrice ? '€' : 'kg';
    }

    getMetricCalculatedHint(focus: LetzteAktionenMetricEditFocus): string {
        const merged = this.getMergedMetricForFocus(focus);
        const anzahl = this.effectiveAnzahlTiere();
        const isPrice = this.isMetricPrice(focus);
        if (this.getMetricEntryMode(focus) === 'gesamt') {
            if (anzahl <= 0) {
                return '';
            }
            const pro = isPrice
                ? formatLetzteAktionPreisProTier(merged)
                : formatLetzteAktionGewichtProTier(merged);
            if (pro === '—') {
                return '';
            }
            return `≈ ${pro}`;
        }
        const gesamt = isPrice
            ? formatLetzteAktionPreisGesamt(merged)
            : formatLetzteAktionGewichtGesamt(merged);
        if (gesamt === '—') {
            return '';
        }
        return `= ${gesamt} gesamt`;
    }

    onMetricCardActivate(focus: LetzteAktionenMetricEditFocus, event?: Event): void {
        if (!this.canEditMetric(focus)) {
            return;
        }
        if (event) {
            const target = event.target as HTMLElement | null;
            if (
                target?.closest(
                    'input, .la-detail-dialog__metric-mwst, .la-detail-dialog__metric-mode-toggle, .mat-mdc-radio-button, .mat-radio-button, .mdc-radio',
                )
            ) {
                return;
            }
            if (event instanceof KeyboardEvent && event.key === ' ') {
                event.preventDefault();
            }
        }
        if (this.editingMetric === focus) {
            this.commitMetricControlToRow(focus);
            this.editingMetric = null;
            return;
        }
        if (this.editingMetric) {
            this.commitMetricControlToRow(this.editingMetric);
        }
        this.editingMetric = focus;
        this.syncProTierCtrlFromGesamt(focus);
        this.focusMetricInput(focus);
    }

    private focusMetricInput(focus: LetzteAktionenMetricEditFocus): void {
        setTimeout(() => {
            const el = document.getElementById(this.metricInputId(focus)) as HTMLInputElement | null;
            el?.focus();
            el?.select?.();
            const card = el?.closest('.la-detail-dialog__metric');
            card?.scrollIntoView({ block: 'center', behavior: 'smooth' });
        }, 0);
    }

    /** Prevent mouse wheel from changing focused metric number inputs while scrolling the dialog. */
    @HostListener('wheel', ['$event'])
    onMetricWheel(event: WheelEvent): void {
        const target = event.target;
        if (
            target instanceof HTMLInputElement &&
            target.type === 'number' &&
            target.classList.contains('la-detail-dialog__metric-input') &&
            document.activeElement === target
        ) {
            event.preventDefault();
        }
    }

    /** Close edit mode on outside click (focusout broke MwSt. before the radio received the click). */
    @HostListener('document:mousedown', ['$event'])
    onDocumentMouseDown(event: MouseEvent): void {
        this.closeMetricEditingIfOutside(event.target);
        this.closeDatumEditingIfOutside(event.target);
    }

    private closeMetricEditingIfOutside(target: EventTarget | null): void {
        if (!this.editingMetric) {
            return;
        }
        const el = target as HTMLElement | null;
        if (el?.closest('.la-detail-dialog__metric--editing')) {
            return;
        }
        const focus = this.editingMetric;
        this.commitMetricControlToRow(focus);
        this.editingMetric = null;
    }

    get primaryGruppeId(): number | null {
        const links = getGruppeLinksForRow(this.row);
        return links.length > 0 ? links[0].gruppe_id : this.row.gruppe_id;
    }

    ngOnInit(): void {
        this.gruppeLinks = getGruppeLinksForRow(this.row);
        this.wireMetricDualFieldSync();
        this.loadContext();
        this.dialogRef.disableClose = true;
        this.subscriptions.add(
            this.dialogRef.backdropClick().subscribe(() => {
                this.onCloseDialog();
            }),
        );
        this.subscriptions.add(
            this.dialogRef.keydownEvents().subscribe(event => {
                if (event.key === 'Escape') {
                    event.preventDefault();
                    this.onCloseDialog();
                }
            }),
        );
        this.subscriptions.add(
            this.tierlisteCache.watchChanged().subscribe(changedId => {
                if (changedId === Number(this.row.tierliste_id)) {
                    this.reloadTierlisteContextFromStepper();
                }
            }),
        );
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    getAktionLabel(): string {
        return getTierLetzteAktionDisplayLabel(this.row);
    }

    get displayAktionId(): number | null {
        const aktionId = Number(this.row.aktion_id) || 0;
        if (aktionId > 0) {
            return aktionId;
        }
        const tierlisteId = Number(this.row.tierliste_id) || 0;
        return tierlisteId > 0 ? tierlisteId : null;
    }

    get displayTierlisteDatumLabel(): string {
        const source = this.canEditTierlisteMeta
            ? this.datumCtrl.value
            : this.resolveTierlisteDatumFromTierliste();
        const parsed = this.parseAusstalldatum(source as Date | string | null | undefined);
        if (!parsed) {
            return '—';
        }
        return formatDate(parsed, 'dd.MM.yyyy', 'de');
    }

    get displayKommentarLabel(): string {
        const value = (this.kommentarCtrl.value ?? '').trim();
        return value || '—';
    }

    startKommentarEdit(event?: Event): void {
        event?.stopPropagation();
        if (!this.canEditTierlisteMeta) {
            return;
        }
        this.isKommentarEditing = true;
        setTimeout(() => this.kommentarInput?.nativeElement?.focus());
    }

    finishKommentarEdit(): void {
        this.isKommentarEditing = false;
    }

    startDatumEdit(event?: Event): void {
        event?.stopPropagation();
        if (!this.canEditTierlisteMeta) {
            return;
        }
        this.isDatumEditing = true;
    }

    finishDatumEdit(): void {
        this.isDatumEditing = false;
        this.tierlisteDatumInput?.nativeElement?.blur();
    }

    private closeDatumEditingIfOutside(target: EventTarget | null): void {
        if (!this.isDatumEditing) {
            return;
        }
        const el = target as HTMLElement | null;
        if (el?.closest('mat-datepicker-content, mat-calendar')) {
            return;
        }
        if (el?.closest('.la-detail-dialog__card--datum')) {
            if (el?.closest('.la-detail-dialog__card-actions, .la-detail-dialog__card-icon-btn')) {
                return;
            }
            this.finishDatumEdit();
            return;
        }
        this.finishDatumEdit();
    }

    getStatusLabel(): string {
        return getLetzteAktionenDisplayedStatusLabel(this.row);
    }

    getStatusChipClass(): string {
        return getLetzteAktionenDisplayedChipClass(this.row);
    }

    continueScans(): void {
        this.openDirectScanEinstallStepper('einstallen');
    }

    private openDirectScanEinstallStepper(initialStep: 'einstallen' | 'review'): void {
        const gruppeId = this.primaryGruppeId;
        const einstallTierlisteId =
            getEinstallTierlisteIdForRow(this.row, this.tierliste) ??
            (Number(this.row.tierliste_id) || 0);
        if (!gruppeId || einstallTierlisteId <= 0) {
            return;
        }
        const stepperData: DashboardEinstallenStepperDialogData = {
            continueDirectScan: {
                gruppeId,
                einstallTierlisteId,
                initialStep,
            },
        };
        this.dialog
            .open(DashboardEinstallenStepperDialogComponent, {
                ...dashboardEinstallenStepperDialogLayout,
                data: stepperData,
            })
            .afterClosed()
            .subscribe(saved => {
                if (saved) {
                    this.dialogRef.close(true);
                }
            });
    }

    isMetricDisplayEmpty(display: string): boolean {
        return display === '—';
    }

    formatPreisGesamt(value: LetzteAktionWertAnzahl | null | undefined): string {
        return formatLetzteAktionPreisGesamt(value);
    }

    formatGewichtGesamt(value: LetzteAktionWertAnzahl | null | undefined): string {
        return formatLetzteAktionGewichtGesamt(value);
    }

    displayEinkaufPreisGesamt(): string {
        return this.formatPreisGesamt(
            this.mergeMetricWithControl(this.einkaufPreisCtrl, this.row.einkaufspreis_avg),
        );
    }

    displayVerkaufPreisGesamt(): string {
        return this.formatPreisGesamt(
            this.mergeMetricWithControl(this.verkaufPreisCtrl, this.row.verkaufspreis_avg),
        );
    }

    displayEinstallGewichtGesamt(): string {
        return this.formatGewichtGesamt(
            this.mergeMetricWithControl(this.einstallGewichtCtrl, this.row.einstallgewicht_avg),
        );
    }

    displayAbgangGewichtGesamt(): string {
        return this.formatGewichtGesamt(
            this.mergeMetricWithControl(this.abgangGewichtCtrl, this.row.abgangsgewicht_avg),
        );
    }

    formatPreis(value: LetzteAktionWertAnzahl | null | undefined): string {
        return this.formatPreisGesamt(value);
    }

    formatTageszunahmen(value: LetzteAktionWertAnzahl | null | undefined): string {
        if (value?.wert == null || Number.isNaN(Number(value.wert))) {
            return '—';
        }
        return `${Number(value.wert).toLocaleString('de-DE', {
            minimumFractionDigits: 1,
            maximumFractionDigits: 1,
        })} kg`;
    }

    hasEmpfaenger(): boolean {
        if (this.isInternTransfer) {
            return this.hasInternZielbetrieb();
        }
        return hasExternEmpfaenger(this.tierliste, this.empfaengerKontakte, this.schlachthof);
    }

    /** All Zielbetriebe / Empfänger with equal display weight (no Kontakt/Schlachthof prefixes). */
    getZielbetriebDisplayLines(): string[] {
        return this.zielbetriebDisplayEntries.map(entry => entry.name);
    }

    getZielbetriebDisplayEntries(): ExternEmpfaengerDisplayEntry[] {
        return this.zielbetriebDisplayEntries;
    }

    trackZielDisplayEntry(index: number, entry: ExternEmpfaengerDisplayEntry): string {
        return `${index}:${entry.name}`;
    }

    trackZielDetailLine(index: number, line: string): string {
        return `${index}:${line}`;
    }

    private rebuildZielbetriebDisplayEntries(): void {
        this.zielbetriebDisplayEntries = this.computeZielbetriebDisplayEntries();
    }

    private computeZielbetriebDisplayEntries(): ExternEmpfaengerDisplayEntry[] {
        if (this.isInternTransfer) {
            const name = this.getInternZielbetriebDisplayName();
            if (!name) {
                return [];
            }
            return [{ name, detailLines: this.getZielbetriebAddressLines() }];
        }
        return getExternEmpfaengerDisplayEntries(
            this.tierliste,
            this.empfaengerKontakte,
            this.schlachthof,
            this.isAusstallen && !this.isInternTransfer ? this.row.herkunft : undefined,
        );
    }

    private getInternZielbetriebDisplayName(): string {
        if (this.zielbetrieb) {
            return (this.zielbetrieb.bezeichnung_final || this.zielbetrieb.bezeichnung || '').trim();
        }
        const zielName = getTierlisteZielbetriebAnzeigeName(this.tierliste);
        return zielName !== '—' ? zielName : '';
    }

    getZielbetriebEmptyLabel(): string {
        return this.isInternTransfer ? 'Kein Zielbetrieb ausgewählt' : 'Kein Empfänger ausgewählt';
    }

    get overviewBetriebLabel(): string {
        const label = (this.row.betrieb || '').trim();
        return label && label !== '—' ? label : '—';
    }

    getZielbetriebDisplayName(): string {
        const lines = this.getZielbetriebDisplayLines();
        if (lines.length > 0) {
            return lines.join(', ');
        }
        return this.getZielbetriebEmptyLabel();
    }

    getZielbetriebAddressLines(): string[] {
        const client = this.zielbetrieb;
        if (client) {
            const lines: string[] = [];
            if (client.vvvo) {
                lines.push(`VVVO: ${client.vvvo}`);
            }
            const strasse = client.strasse_final || client.strasse;
            const plz = client.plz_final || client.plz;
            const ort = client.ort_final || client.ort;
            if (strasse) {
                lines.push(strasse);
            }
            if (plz || ort) {
                lines.push(`${plz || ''} ${ort || ''}`.trim());
            }
            return lines;
        }
        if (this.tierliste) {
            const lines: string[] = [];
            if (this.tierliste.kunde_vvvo_zielbetrieb) {
                lines.push(`VVVO: ${this.tierliste.kunde_vvvo_zielbetrieb}`);
            }
            if (this.tierliste.kunde_strasse_zielbetrieb) {
                lines.push(this.tierliste.kunde_strasse_zielbetrieb);
            }
            const plzOrt = [this.tierliste.kunde_plz_zielbetrieb, this.tierliste.kunde_ort_zielbetrieb]
                .filter(Boolean)
                .join(' ');
            if (plzOrt) {
                lines.push(plzOrt);
            }
            return lines;
        }
        return [];
    }

    onZielCardActivate(event?: Event): void {
        if (!this.canEditZielbetrieb) {
            return;
        }
        if (event instanceof KeyboardEvent && event.key === ' ') {
            event.preventDefault();
        }
        this.zielbetriebAendern();
    }

    zielbetriebAendern(): void {
        if (this.isInternTransfer) {
            this.openInternZielbetriebPicker();
            return;
        }
        if (!this.tierliste) {
            this.messageService.alertMessage('Tierliste konnte nicht geladen werden.');
            return;
        }
        this.dialog
            .open(AusstallenEmpfaengerDialogComponent, {
                width: '760px',
                maxWidth: 'calc(100vw - 24px)',
                maxHeight: '90vh',
                panelClass: ['letzte-aktionen-empfaenger-dialog-panel', 'ausstallen-empfaenger-dialog-panel'],
                data: {
                    tierliste: this.tierliste,
                    gruppeKundeId: this.gruppeStandort?.gruppe_id,
                    flowType: 'ausstallen_extern',
                },
            })
            .afterClosed()
            .subscribe({
                next: (result: AusstallenEmpfaengerDialogResult) => {
                    if (!result) {
                        return;
                    }
                    this.schlachthof = result.schlachthof;
                    this.empfaengerKontakte = result.kontakte ?? [];
                    this.tierliste = patchTierlisteFromExternEmpfaenger(
                        result.tierliste,
                        this.empfaengerKontakte,
                        this.schlachthof,
                    );
                    this.syncRowHerkunftFromEmpfaenger();
                    if (this.row.tierliste_id) {
                        this.tierlisteCache.invalidate(this.row.tierliste_id);
                        this.refreshOpenAbgangModalTierliste(this.row.tierliste_id, this.tierliste);
                    }
                    this.rebuildZielbetriebDisplayEntries();
                },
            });
    }

    private openInternZielbetriebPicker(): void {
        if (!this.tierliste) {
            this.messageService.alertMessage('Tierliste konnte nicht geladen werden.');
            return;
        }
        const inhaberKundeId =
            Number(this.gruppeKundeId ?? this.tierliste.kunde_id_abgang) || null;
        this.dialog
            .open(AusstallenEmpfaengerDialogComponent, {
                width: '760px',
                maxWidth: 'calc(100vw - 24px)',
                maxHeight: '90vh',
                panelClass: ['letzte-aktionen-empfaenger-dialog-panel', 'ausstallen-empfaenger-dialog-panel'],
                data: {
                    tierliste: this.tierliste,
                    gruppeKundeId: this.gruppeStandort?.gruppe_id,
                    flowType: 'umstallen_intern',
                    inhaberKundeId,
                },
                disableClose: false,
            })
            .afterClosed()
            .subscribe({
                next: (result: AusstallenEmpfaengerDialogResult | undefined) => {
                    if (!result || !this.tierliste) {
                        return;
                    }
                    this.tierliste = result.tierliste;
                    this.zielbetrieb = result.zielbetrieb ?? null;
                    this.rebuildZielbetriebDisplayEntries();
                    if (this.row.tierliste_id) {
                        this.tierlisteCache.invalidate(this.row.tierliste_id);
                        this.refreshOpenAbgangModalTierliste(this.row.tierliste_id, this.tierliste);
                    }
                },
            });
    }

    private applyInternZielbetriebSelection(betrieb: Client): void {
        const kundeId = Number(betrieb.kunde_id);
        if (kundeId <= 0) {
            return;
        }
        const label = (betrieb.bezeichnung_final || betrieb.bezeichnung || '').trim();
        this.zielbetrieb = betrieb;
        this.tierliste!.kunde_id_einstallen = kundeId;
        this.tierliste!.kunde_id_zielbetrieb = kundeId;
        this.tierliste!.kunde_einstallen = label;
        this.tierliste!.kunde_zielbetrieb = label;
        this.tierliste!.kunde_zusatz_einstallen =
            (betrieb.zusatz_final || betrieb.zusatz || '').trim() || undefined;
        this.tierliste!.kunde_zusatz_zielbetrieb = this.tierliste!.kunde_zusatz_einstallen;
        if (betrieb.vvvo) {
            this.tierliste!.kunde_vvvo_einstallen = betrieb.vvvo;
            this.tierliste!.kunde_vvvo_zielbetrieb = betrieb.vvvo;
        }
        this.rebuildZielbetriebDisplayEntries();
    }

    private persistInternZielbetrieb(): void {
        if (!this.tierliste?.tierliste_id || !this.zielbetrieb?.kunde_id) {
            return;
        }
        const kundeId = Number(this.zielbetrieb.kunde_id);
        const payload = this.kommentarNurWennGeaendert({ ...this.tierliste });
        payload.status_id = this.statusIdForOverviewSave(payload.status_id);
        payload.kunde_id_einstallen = kundeId;
        payload.kunde_id_zielbetrieb = kundeId;

        this.isSaving = true;
        this.postTierlisteUpdate(payload)
            .then(liste => {
                this.tierliste = { ...this.tierliste, ...liste };
                this.applyInternZielbetriebSelection(this.zielbetrieb!);
                this.initialZielKundeId = kundeId;
                if (this.row.tierliste_id) {
                    this.tierlisteCache.invalidate(this.row.tierliste_id);
                    this.refreshOpenAbgangModalTierliste(this.row.tierliste_id, this.tierliste);
                }
                this.messageService.infoMessage('Zielbetrieb wurde gespeichert.');
            })
            .catch(err => this.messageService.errorMessage('Zielbetrieb konnte nicht gespeichert werden.', err))
            .finally(() => {
                this.isSaving = false;
            });
    }

    private hasInternZielbetrieb(): boolean {
        if (this.zielbetrieb?.kunde_id) {
            return true;
        }
        const kundeId = Number(this.tierliste?.kunde_id_einstallen) || Number(this.tierliste?.kunde_id_zielbetrieb);
        return kundeId > 0;
    }

    /** Updates an open Ausstallen dialog: immediate patch, then authoritative read_one (incl. BBT). */
    private refreshOpenAbgangModalTierliste(tierlisteId: number, patched?: Tierliste): void {
        const id = Number(tierlisteId);
        if (id <= 0) {
            return;
        }
        const pushToAbgang = (liste: Tierliste) => {
            const active = this.abgangService.tierliste;
            if (!active?.tierliste_id || Number(active.tierliste_id) !== id) {
                return;
            }
            this.abgangService.setAbgangsliste(liste, false, false);
        };
        if (patched) {
            pushToAbgang(patched);
        }
        const params = new HttpParams().set('tierliste_id', String(id));
        const kundeId = Number(this.localStorageService.getCurrentClient()?.kunde_id) || 0;
        const tierlisteParams = kundeId > 0 ? params.set('kunde_id', String(kundeId)) : params;
        this.api.get(this.apiBaseUrl + 'tierliste/read_one_kundenportal.php', tierlisteParams).subscribe({
            next: (liste: Tierliste) => pushToAbgang(liste),
        });
    }

    getGruppeDetailLink(gruppeId: number): (string | number)[] {
        return ['/gruppen/aktuelle', gruppeId];
    }

    onGruppeLinkClick(event: MouseEvent, gruppeId: number): void {
        event.preventDefault();
        this.closeDialogWithPendingSave(saved => {
            this.dialogRef.close(saved);
            void this.router.navigate(this.getGruppeDetailLink(gruppeId));
        });
    }

    onCloseDialog(): void {
        this.closeDialogWithPendingSave(saved => this.dialogRef.close(saved));
    }

    private closeDialogWithPendingSave(onClosed: (saved: boolean) => void): void {
        if (this.isSaving || this.isLoading) {
            return;
        }

        this.finalizeActiveMetricEditing();

        const saveSteps: Array<() => Promise<void>> = [];
        const hadMetricChanges = this.canEditGewichtPreis && this.hasGewichtPreisChanges();
        const hadTierlisteMetaChanges = this.canEditTierlisteMeta && this.tierlisteMetaChanged();
        const hadZielbetriebChanges = this.canEditZielbetrieb && this.zielbetriebChanged();

        if (hadTierlisteMetaChanges) {
            if (!this.tierliste) {
                this.messageService.alertMessage('Tierliste konnte nicht geladen werden.');
                return;
            }
            saveSteps.push(() => this.saveTierlisteMeta());
        }

        if (hadZielbetriebChanges) {
            if (!this.tierliste) {
                this.messageService.alertMessage('Tierliste konnte nicht geladen werden.');
                return;
            }
            saveSteps.push(() => this.saveZielbetrieb());
        }

        if (hadMetricChanges) {
            if (!this.validateMwstBeforeSave()) {
                return;
            }
            saveSteps.push(() => this.persistGewichtPreisMetrics());
        }

        if (saveSteps.length === 0) {
            onClosed(false);
            return;
        }

        const runSave = () => {
            this.isSaving = true;
            this.runSaveStepsSequentially(saveSteps)
                .then(() => {
                    if (hadMetricChanges) {
                        this.applyMetricSaveSuccess();
                    }
                    if (this.row.tierliste_id) {
                        this.tierlisteCache.invalidate(this.row.tierliste_id);
                        if (hadZielbetriebChanges) {
                            this.refreshOpenAbgangModalTierliste(this.row.tierliste_id, this.tierliste);
                        }
                    }
                    onClosed(true);
                })
                .catch(err => {
                    this.messageService.errorMessage('Fehler beim Speichern', err);
                })
                .finally(() => {
                    this.isSaving = false;
                });
        };

        if (!hadMetricChanges) {
            runSave();
            return;
        }

        void this.resolveOverwriteModeBeforeSave().then(mode => {
            if (mode == null) {
                this.restoreMetricsAfterOverwriteCancel();
                return;
            }
            this.pendingOverwriteMode = mode;
            runSave();
        });
    }

    onScansFortsetzen(): void {
        this.runActionAfterPendingMetricsSave(() => {
            if (this.canShowContinueScansButton) {
                this.continueScans();
                return;
            }
            this.openAbgangStepper('tiere');
        });
    }

    listeAbschliessen(): void {
        this.runActionAfterPendingMetricsSave(() => {
            if (this.canShowContinueScansButton) {
                this.openDirectScanEinstallStepper('review');
                return;
            }
            this.openAbgangStepper('ausstallen');
        });
    }

    private openAbgangStepper(initialStep: 'tiere' | 'ausstallen'): void {
        if (this.isSaving || this.isLoading || !this.canShowScansFortsetzenButton || !this.tierliste) {
            return;
        }
        if (this.listeAbschliessenStepperHandler) {
            const listeForStepper: Tierliste = {
                ...this.tierliste,
                umstallen: Number(this.tierliste.umstallen) === 1 ? 1 : 0,
                transfer_innerhalb_betrieb: Number(this.tierliste.umstallen) === 1 ? 1 : 0,
            };
            this.listeAbschliessenStepperHandler.open(listeForStepper, { initialStep }).subscribe({
                next: saved => {
                    this.reloadTierlisteContextFromStepper();
                    if (saved) {
                        this.dialogRef.close(true);
                    }
                },
            });
        }
    }

    /** Reload tierliste + Empfänger/Zielbetrieb after stepper auto-save or close. */
    private reloadTierlisteContextFromStepper(): void {
        const tierlisteId = Number(this.row.tierliste_id) || 0;
        if (tierlisteId <= 0 || !this.isAusstallen) {
            return;
        }
        this.tierlisteCache.invalidate(tierlisteId);
        this.subscriptions.add(
            this.tierlisteCache.get(tierlisteId).subscribe({
                next: tierliste => {
                    if (!tierliste?.tierliste_id) {
                        return;
                    }
                    const entwurf = this.tierlisteMetaChanged() ? this.kommentarCtrl.value : undefined;
                    this.tierliste = tierliste;
                    this.prefillFromRowAndTierliste();
                    if (entwurf !== undefined) {
                        this.kommentarCtrl.setValue(entwurf, { emitEvent: false });
                    }
                    this.refreshAnzahlTiereFromListe();
                    this.resetAndReloadEmpfaengerOrZielbetrieb();
                },
                error: () => {
                    /* keep previous display on transient errors */
                },
            }),
        );
    }

    private resetAndReloadEmpfaengerOrZielbetrieb(): void {
        if (!this.canEditZielbetrieb) {
            return;
        }
        this.zielbetrieb = null;
        this.schlachthof = null;
        this.empfaengerKontakte = [];
        this.zielbetriebDisplayEntries = [];
        this.initialZielKundeId = null;
        this.initialSchlachthofKundeId = null;
        this.initialKontaktIds = [];
        this.initialKundeIdEinstallen = null;
        this.initialKundeIdZielbetrieb = null;
        if (this.isInternTransfer) {
            this.loadZielbetriebClient();
        } else {
            this.loadExternEmpfaenger();
        }
    }

    inGruppeImportieren(): void {
        if (this.isSaving || this.isLoading || !this.canShowImportierenButton || !this.tierliste) {
            return;
        }
        this.runActionAfterPendingMetricsSave(() => this.executeInGruppeImportieren());
    }

    private executeInGruppeImportieren(): void {
        if (!this.tierliste) {
            return;
        }
        const knownClientId = Number(this.tierliste.kunde_id_einstallen) || 0;
        if (knownClientId > 0) {
            const params = new HttpParams().set('kunde_id', String(knownClientId));
            this.api.get(this.apiBaseUrl + 'kunde/read_one_kundenportal.php', params).subscribe({
                next: (kunde: Client) => {
                    if (kunde) {
                        this.importTierlisteInVorhandeneGruppe(this.tierliste!, kunde);
                    }
                },
                error: err => this.messageService.errorMessage('Fehler', err),
            });
            return;
        }

        const currentClient = this.localStorageService.getCurrentClient();
        if (currentClient) {
            this.importTierlisteInVorhandeneGruppe(this.tierliste, currentClient);
            return;
        }

        this.changeCurrentClientService.openChangeDialog().subscribe({
            next: (client: Client) => {
                if (client) {
                    this.importTierlisteInVorhandeneGruppe(this.tierliste!, client);
                }
            },
        });
    }

    /** DB updates for the same tierliste/gruppe must run one after another to avoid deadlocks. */
    private runSaveStepsSequentially(steps: Array<() => Promise<void>>): Promise<void> {
        return steps.reduce((chain, step) => chain.then(() => step()), Promise.resolve());
    }

    private zielbetriebChanged(): boolean {
        if (this.isInternTransfer) {
            const current = Number(this.zielbetrieb?.kunde_id);
            if (current <= 0) {
                return false;
            }
            return current !== this.initialZielKundeId;
        }
        const schlachthofId = Number(this.schlachthof?.kunde_id) || 0;
        if (schlachthofId !== (this.initialSchlachthofKundeId ?? 0)) {
            return true;
        }
        const einstallId = Number(this.tierliste?.kunde_id_einstallen) || 0;
        if (einstallId !== (this.initialKundeIdEinstallen ?? 0)) {
            return true;
        }
        const zielId = Number(this.tierliste?.kunde_id_zielbetrieb) || 0;
        if (zielId !== (this.initialKundeIdZielbetrieb ?? 0)) {
            return true;
        }
        const kontaktIds = this.empfaengerKontakte
            .map(k => k.kontakt_id)
            .filter((id): id is number => id != null && id > 0)
            .sort((a, b) => a - b);
        const initial = [...this.initialKontaktIds].sort((a, b) => a - b);
        if (kontaktIds.length !== initial.length) {
            return true;
        }
        return kontaktIds.some((id, i) => id !== initial[i]);
    }

    private hasMergedPositiveGesamt(
        ctrl: FormControl<number | null>,
        rowMetric: LetzteAktionWertAnzahl | null | undefined,
    ): boolean {
        return this.getGesamtFromMergedMetric(ctrl, rowMetric) != null;
    }

    private getGesamtFromMergedMetric(
        ctrl: FormControl<number | null>,
        rowMetric: LetzteAktionWertAnzahl | null | undefined,
    ): number | null {
        const merged = this.mergeMetricWithControl(ctrl, rowMetric);
        const preis = getLetzteAktionPreisGesamt(merged);
        if (preis != null && preis > 0) {
            return preis;
        }
        const gewicht = getLetzteAktionGewichtGesamt(merged);
        if (gewicht != null && gewicht > 0) {
            return gewicht;
        }
        return null;
    }

    private getEinstallDatumYmd(): string | null {
        return getLetzteAktionEinstallDatumYmd(this.row);
    }

    private validateMwstBeforeSave(): boolean {
        if (!this.canShowPreis) {
            return true;
        }
        const needsEinkaufMwst = this.hasMergedPositiveGesamt(this.einkaufPreisCtrl, this.row.einkaufspreis_avg);
        const needsVerkaufMwst =
            this.isAusstallen && this.hasMergedPositiveGesamt(this.verkaufPreisCtrl, this.row.verkaufspreis_avg);

        if (needsEinkaufMwst && this.einkaufMwstCtrl.invalid) {
            this.messageService.alertMessage('Bitte einen MwSt.-Satz für den Einkaufspreis wählen.');
            return false;
        }
        if (needsVerkaufMwst && this.verkaufMwstCtrl.invalid) {
            this.messageService.alertMessage('Bitte einen MwSt.-Satz für den Verkaufspreis wählen.');
            return false;
        }
        return true;
    }

    private loadContext(): void {
        const context$ = this.loadTierlisteForDialog().pipe(
            switchMap(tierliste => {
                if (tierliste?.tierliste_id && !this.row.einstall_tierliste_id) {
                    const einstallId = getEinstallTierlisteIdForRow(this.row, tierliste);
                    if (einstallId && einstallId !== tierliste.tierliste_id) {
                        this.row.einstall_tierliste_id = einstallId;
                    }
                }
                if (isPendingImportEinstallRow(this.row, tierliste)) {
                    return of({
                        gruppe: null as Gruppe | null,
                        tierliste,
                        linkedEinstallTierlisteId: null as number | null,
                    });
                }
                const gruppeId = this.resolveGruppeIdForLoad(tierliste);
                if (!gruppeId) {
                    return of({
                        gruppe: null as Gruppe | null,
                        tierliste,
                        linkedEinstallTierlisteId: null as number | null,
                    });
                }
                const gruppeParams = new HttpParams().set('gruppe_id', String(gruppeId));
                return this.api
                    .get(this.apiBaseUrl + 'gruppe/read_one_kundenportal.php', gruppeParams)
                    .pipe(
                        switchMap(gruppe =>
                            this.resolveLinkedEinstallTierlisteId(tierliste, (gruppe as Gruppe).gruppe_id).pipe(
                                map(linkedEinstallTierlisteId => ({
                                    gruppe: gruppe as Gruppe,
                                    tierliste,
                                    linkedEinstallTierlisteId,
                                })),
                            ),
                        ),
                    );
            }),
        );

        this.subscriptions.add(
            context$.subscribe({
                next: ({ gruppe, tierliste, linkedEinstallTierlisteId }) => {
                    this.tierliste = tierliste;
                    this.linkedEinstallTierlisteId = linkedEinstallTierlisteId;
                    if (isPendingImportEinstallRow(this.row, tierliste)) {
                    this.prefillFromRowAndTierliste();
                    this.refreshAnzahlTiereFromListe();
                    this.rebuildZielbetriebDisplayEntries();
                    if (this.canEditZielbetrieb) {
                        if (this.isInternTransfer) {
                            this.loadZielbetriebClient();
                        } else {
                            this.loadExternEmpfaenger();
                        }
                    }
                    this.isLoading = false;
                    return;
                }
                    if (!gruppe?.gruppe_id) {
                        if (this.canLoadAusstallContextWithoutGruppe(tierliste)) {
                            this.prefillFromRowAndTierliste();
                            this.refreshAnzahlTiereFromListe();
                            this.rebuildZielbetriebDisplayEntries();
                            if (this.canEditZielbetrieb) {
                                if (this.isInternTransfer) {
                                    this.loadZielbetriebClient();
                                } else {
                                    this.loadExternEmpfaenger();
                                }
                            }
                            this.loadGruppeStandortForMetricsIfNeeded();
                            this.loadTierlisteKontextMetricsIfNeeded();
                            this.isLoading = false;
                            return;
                        }
                        this.isLoading = false;
                        this.loadError = 'Keine Gruppe für diese Aktion gefunden.';
                        return;
                    }
                    this.gruppeKundeId = Number(gruppe.kunde_id) > 0 ? Number(gruppe.kunde_id) : null;
                    this.gruppeStandort = this.buildGruppeStandort(gruppe);
                    this.prefillFromRowAndTierliste();
                    this.refreshAnzahlTiereFromListe();
                    this.rebuildZielbetriebDisplayEntries();
                    if (this.canEditZielbetrieb) {
                        if (this.isInternTransfer) {
                            this.loadZielbetriebClient();
                        } else {
                            this.loadExternEmpfaenger();
                        }
                    }
                    this.loadTierlisteKontextMetricsIfNeeded();
                    this.isLoading = false;
                },
                error: err => {
                    this.isLoading = false;
                    this.loadError = 'Daten konnten nicht geladen werden.';
                    this.messageService.errorMessage('Fehler', err);
                },
            }),
        );
    }

    private loadTierlisteForDialog() {
        if (!this.row.tierliste_id || this.row.tierliste_id <= 0) {
            return of(null as Tierliste | null);
        }
        if (this.isAusstallen) {
            return this.tierlisteCache.get(this.row.tierliste_id).pipe(catchError(() => of(null)));
        }
        if (isPendingImportEinstallRow(this.row)) {
            const ausstallTid =
                (getAusstallTierlisteIdForImportRow(this.row, this.tierliste) ??
                    Number(this.row.tierliste_id)) ||
                0;
            if (ausstallTid > 0) {
                return this.tierlisteCache.get(ausstallTid).pipe(catchError(() => of(null)));
            }
        }
        const knownEinstallId = getEinstallTierlisteIdForRow(this.row);
        if (knownEinstallId) {
            return this.tierlisteCache.get(knownEinstallId).pipe(catchError(() => of(null)));
        }
        const gruppeId = this.primaryGruppeId ?? 0;
        const resolveParams = new HttpParams()
            .set('tierliste_id', String(this.row.tierliste_id))
            .set('gruppe_id', String(gruppeId));
        return this.api.get(this.apiBaseUrl + 'gruppe/read_resolve_einstall_tierliste.php', resolveParams).pipe(
            switchMap((res: { einstall_tierliste_id?: number | null }) => {
                const einstallId = Number(res?.einstall_tierliste_id) || 0;
                if (einstallId > 0) {
                    this.row.einstall_tierliste_id = einstallId;
                    return this.tierlisteCache.get(einstallId).pipe(catchError(() => of(null)));
                }
                return this.tierlisteCache.get(this.row.tierliste_id!).pipe(catchError(() => of(null)));
            }),
            catchError(() => this.tierlisteCache.get(this.row.tierliste_id!).pipe(catchError(() => of(null)))),
        );
    }

    /** Imported Einstallen (nur status 163): Zielgruppe aus tierliste; sonst Zeilen-Gruppe. */
    private resolveGruppeIdForLoad(tierliste: Tierliste | null): number | null {
        if (isPendingImportEinstallRow(this.row, tierliste)) {
            return null;
        }
        if (this.row.aktion === TierLetzteAktionTyp.einstallen) {
            const zielGruppeId =
                Number(tierliste?.gruppe_id_einstallen) > 0
                    ? Number(tierliste?.gruppe_id_einstallen)
                    : Number(this.row.gruppe_id) > 0
                      ? Number(this.row.gruppe_id)
                      : 0;
            if (zielGruppeId > 0) {
                return zielGruppeId;
            }
        }
        if (isImportedEinstallAbgeschlossen(this.row, tierliste)) {
            const gid = Number(tierliste?.gruppe_id_einstallen);
            if (gid > 0) {
                return gid;
            }
        }
        return this.primaryGruppeId;
    }

    private isTierlisteErstelltMetricsContext(): boolean {
        return (
            !!this.data.tierlisteKontext &&
            this.isAusstallen &&
            !!this.row.tierliste_id &&
            getLetzteAktionenStatusPhase(this.row) === 'erstellt'
        );
    }

    private loadGruppeStandortForMetricsIfNeeded(): void {
        if (!this.isTierlisteErstelltMetricsContext() || this.gruppeStandort?.gs_id) {
            return;
        }
        const gruppeId = Number(this.row.gruppe_id) || this.primaryGruppeId || 0;
        if (gruppeId <= 0) {
            return;
        }
        const params = new HttpParams().set('gruppe_id', String(gruppeId));
        this.subscriptions.add(
            this.api.get(this.apiBaseUrl + 'gruppe/read_one_kundenportal.php', params).subscribe({
                next: gruppe => {
                    if (!gruppe?.gruppe_id) {
                        return;
                    }
                    this.gruppeKundeId = Number(gruppe.kunde_id) > 0 ? Number(gruppe.kunde_id) : null;
                    this.gruppeStandort = this.buildGruppeStandort(gruppe as Gruppe);
                    this.prefillFromRowAndTierliste();
                },
            }),
        );
    }

    private loadTierlisteKontextMetricsIfNeeded(): void {
        if (!this.isTierlisteErstelltMetricsContext()) {
            return;
        }
        if (
            !this.localStorageService.hasPermission(PERMISSION_PREISE) &&
            !this.localStorageService.hasPermission(PERMISSION_GEWICHTE)
        ) {
            return;
        }

        const payloadRows = [
            {
                tierliste_id: this.row.tierliste_id ?? 0,
                gruppe_id: Number(this.row.gruppe_id) || this.primaryGruppeId || 0,
                aktion: this.row.aktion,
                datum:
                    this.row.datum_raw ??
                    (this.row.datum ? this.row.datum.toISOString().slice(0, 19).replace('T', ' ') : ''),
            },
        ];

        this.subscriptions.add(
            this.api.post(this.apiBaseUrl + 'gruppe/read_letzte_aktionen_metrics.php', { rows: payloadRows }).subscribe({
                next: (response: { records?: unknown[] }) => {
                    const metric = (Array.isArray(response?.records) ? response.records[0] : null) as
                        | Record<string, unknown>
                        | null
                        | undefined;
                    if (!metric) {
                        return;
                    }
                    this.row.einkaufspreis_avg = parseWertAnzahl(
                        metric.einkaufspreis_avg as LetzteAktionWertAnzahl | null | undefined,
                    );
                    this.row.verkaufspreis_avg = parseWertAnzahl(
                        metric.verkaufspreis_avg as LetzteAktionWertAnzahl | null | undefined,
                    );
                    this.row.erloesdifferenz_avg = parseWertAnzahl(
                        metric.erloesdifferenz_avg as LetzteAktionWertAnzahl | null | undefined,
                    );
                    this.row.tageszunahmen_avg = parseWertAnzahl(
                        metric.tageszunahmen_avg as LetzteAktionWertAnzahl | null | undefined,
                    );
                    this.row.einstallgewicht_avg = parseWertAnzahl(
                        metric.einstallgewicht_avg as LetzteAktionWertAnzahl | null | undefined,
                    );
                    this.row.abgangsgewicht_avg = parseWertAnzahl(
                        metric.abgangsgewicht_avg as LetzteAktionWertAnzahl | null | undefined,
                    );
                    const einstallTid = Number(metric.einstall_tierliste_id);
                    if (einstallTid > 0) {
                        this.row.einstall_tierliste_id = einstallTid;
                    }
                    this.prefillFromRowAndTierliste();
                },
                error: () => {
                    /* keep empty metrics — user can still enter values */
                },
            }),
        );
    }

    private canLoadAusstallContextWithoutGruppe(tierliste: Tierliste | null): boolean {
        if (!this.isAusstallen || !tierliste?.tierliste_id) {
            return false;
        }
        if (isGlobalAusstallTierliste(tierliste, this.row)) {
            return true;
        }
        return (Number(this.row.gruppe_id) || 0) > 0;
    }

    private buildGruppeStandort(gruppe: Gruppe): GruppeStandort {
        const gs = new GruppeStandort();
        gs.gs_id = gruppe.gs_id;
        gs.gruppe_id = gruppe.gruppe_id;
        gs.gruppe = gruppe.bezeichnung || gruppe.herdenname || String(gruppe.gruppe_id);
        return gs;
    }

    /** Tiere on the tierliste — align with table column (row.anzahl_tiere) when live/API count is missing. */
    get displayAnzahlTiere(): number {
        return this.effectiveAnzahlTiere();
    }

    private prefillFromRowAndTierliste(): void {
        const rowCount = Math.max(0, Number(this.row.anzahl_tiere) || 0);
        const listeCount = Number(this.tierliste?.anzahl_tiere);
        if (isPendingImportEinstallRow(this.row, this.tierliste)) {
            // Live count from Letzte Aktionen row (all groups on Ausstall-liste); read_one anzahl can be 0.
            this.anzahlTiere = rowCount;
        } else if (this.tierliste != null && !Number.isNaN(listeCount) && listeCount > 0) {
            this.anzahlTiere = listeCount;
        } else {
            this.anzahlTiere = rowCount;
        }

        if (this.isAusstallen) {
            // Metrics from this row's gruppe on the tierliste (connected multi-group rows).
            this.prefillPreisFromMetric(this.row.verkaufspreis_avg, this.verkaufPreisCtrl);
            this.prefillGewichtFromMetric(this.row.abgangsgewicht_avg, this.abgangGewichtCtrl);
            this.prefillPreisFromMetric(this.row.einkaufspreis_avg, this.einkaufPreisCtrl);
            this.prefillGewichtFromMetric(this.row.einstallgewicht_avg, this.einstallGewichtCtrl);
        } else {
            this.prefillPreisFromMetric(this.row.einkaufspreis_avg, this.einkaufPreisCtrl);
            // Imported Einstallen: totals from target gruppe_tiere, not tierliste.gewicht_gesamt_einstallen.
            this.prefillGewichtFromMetric(this.row.einstallgewicht_avg, this.einstallGewichtCtrl);
        }
        this.captureInitialMetricSaveFingerprint();
        this.prefillTierlisteMetaFields();
        if (this.isEinstallen) {
            const handlerLabel = (this.tierliste?.viehhaendler_name || '').trim();
            if (handlerLabel) {
                this.row.handler = handlerLabel;
            }
        }
    }

    clearAusstalldatum(): void {
        this.datumCtrl.setValue(null);
        this.finishDatumEdit();
    }

    private prefillTierlisteMetaFields(): void {
        if (!this.showTierlisteMetaFields) {
            return;
        }
        this.kommentarCtrl.setValue(this.tierliste?.kommentar ?? '', { emitEvent: false });
        this.datumCtrl.setValue(this.resolveTierlisteDatumFromTierliste(), { emitEvent: false });
        this.isKommentarEditing = false;
        this.isDatumEditing = false;
        this.captureInitialTierlisteMetaFingerprint();
    }

    /** Persisted Ausstalldatum from tierliste only — null/empty stays cleared (no row fallback). */
    private resolveTierlisteDatumFromTierliste(): Date | null {
        if (!this.tierliste) {
            return null;
        }
        const raw = this.tierliste.datum_abgang as Date | string | null | undefined;
        if (raw == null || raw === '') {
            return null;
        }
        return this.parseAusstalldatum(raw);
    }

    private parseAusstalldatum(value: Date | string | null | undefined): Date | null {
        if (value == null || value === '') {
            return null;
        }
        const date = value instanceof Date ? new Date(value.getTime()) : new Date(value);
        if (Number.isNaN(date.getTime())) {
            return null;
        }
        date.setHours(0, 0, 0, 0);
        return date;
    }

    private formatDatumForApi(value: Date | string | null | undefined): string | null {
        const parsed = this.parseAusstalldatum(value);
        if (!parsed) {
            return null;
        }
        return formatDate(parsed, 'yyyy-MM-dd', 'de', 'Europe/Berlin');
    }

    private captureInitialTierlisteMetaFingerprint(): void {
        this.initialTierlisteMetaFingerprint = this.buildTierlisteMetaFingerprint();
    }

    private buildTierlisteMetaFingerprint(): string {
        return JSON.stringify({
            kommentar: (this.kommentarCtrl.value ?? '').trim(),
            datum: this.formatDatumForApi(this.datumCtrl.value),
        });
    }

    private tierlisteMetaChanged(): boolean {
        return this.buildTierlisteMetaFingerprint() !== this.initialTierlisteMetaFingerprint;
    }

    private syncRowDatumFromTierlisteMeta(): void {
        const formatted = this.formatDatumForApi(this.datumCtrl.value);
        if (formatted) {
            this.row.datum = new Date(formatted);
            this.row.datum_raw = formatDate(this.row.datum, 'yyyy-MM-dd HH:mm:ss', 'de');
        } else {
            this.row.datum_raw = null;
        }
    }

    /** Offene Übersicht bleibt Status 161. Abschließen setzt 162 erst im Folgedialog. */
    private statusIdForOverviewSave(current: number | null | undefined): number {
        if (getLetzteAktionenStatusPhase(this.row) === 'erstellt') {
            return 161;
        }
        const statusId = Number(current);
        return statusId > 0 ? statusId : 161;
    }

    /** Anderer Speichervorgang: Kommentar nur mitsenden, wenn das Feld hier geändert wurde. */
    private kommentarNurWennGeaendert(payload: Tierliste): Tierliste {
        if (this.canEditTierlisteMeta && this.tierlisteMetaChanged()) {
            payload.kommentar = (this.kommentarCtrl.value ?? '').trim();
            return payload;
        }
        return ohneTierlisteKommentar(payload);
    }

    private saveTierlisteMeta(): Promise<void> {
        if (!this.tierliste) {
            return Promise.reject(new Error('Tierliste fehlt'));
        }
        const formattedDatum = this.formatDatumForApi(this.datumCtrl.value);
        const payload = { ...this.tierliste };
        payload.kommentar = (this.kommentarCtrl.value ?? '').trim();
        payload.datum_abgang = (formattedDatum ?? null) as unknown as Date;
        payload.status_id = this.statusIdForOverviewSave(payload.status_id);
        return this.postTierlisteUpdate(payload).then(liste => {
            this.tierliste = { ...this.tierliste, ...liste, status_id: payload.status_id };
            if (formattedDatum == null) {
                this.tierliste.datum_abgang = null as unknown as Date;
            }
            this.datumCtrl.setValue(this.resolveTierlisteDatumFromTierliste(), { emitEvent: false });
            this.kommentarCtrl.setValue(this.tierliste.kommentar ?? '', { emitEvent: false });
            this.syncRowDatumFromTierlisteMeta();
            this.captureInitialTierlisteMetaFingerprint();
            this.data.onRowChanged?.();
        });
    }

    private finalizeActiveMetricEditing(): void {
        if (!this.editingMetric) {
            return;
        }
        this.finalizeMetricGesamtFromEntryMode(this.editingMetric);
        this.commitMetricControlToRow(this.editingMetric);
        this.editingMetric = null;
    }

    private captureInitialMetricSaveFingerprint(): void {
        this.initialMetricGesamtSnapshot = {
            einkaufPreis: this.einkaufPreisCtrl.value,
            verkaufPreis: this.verkaufPreisCtrl.value,
            einstallGewicht: this.einstallGewichtCtrl.value,
            abgangGewicht: this.abgangGewichtCtrl.value,
            einkaufMwst: this.einkaufMwstCtrl.value ?? 7,
            verkaufMwst: this.verkaufMwstCtrl.value ?? 7,
        };
        this.initialRowMetricsSnapshot = {
            einkaufspreis_avg: this.cloneWertAnzahl(this.row.einkaufspreis_avg),
            verkaufspreis_avg: this.cloneWertAnzahl(this.row.verkaufspreis_avg),
            einstallgewicht_avg: this.cloneWertAnzahl(this.row.einstallgewicht_avg),
            abgangsgewicht_avg: this.cloneWertAnzahl(this.row.abgangsgewicht_avg),
        };
        this.initialMetricSaveFingerprint = this.buildMetricSaveFingerprint();
    }

    private cloneWertAnzahl(metric: LetzteAktionWertAnzahl | null | undefined): LetzteAktionWertAnzahl | null {
        if (!metric) {
            return null;
        }
        return {
            wert: metric.wert,
            anzahl: metric.anzahl,
        };
    }

    /** After Abbrechen in overwrite confirm: restore weights/prices to values before the edit. */
    private restoreMetricsAfterOverwriteCancel(): void {
        this.editingMetric = null;
        const snap = this.initialMetricGesamtSnapshot;
        const rowSnap = this.initialRowMetricsSnapshot;
        if (rowSnap) {
            this.row.einkaufspreis_avg = this.cloneWertAnzahl(rowSnap.einkaufspreis_avg);
            this.row.verkaufspreis_avg = this.cloneWertAnzahl(rowSnap.verkaufspreis_avg);
            this.row.einstallgewicht_avg = this.cloneWertAnzahl(rowSnap.einstallgewicht_avg);
            this.row.abgangsgewicht_avg = this.cloneWertAnzahl(rowSnap.abgangsgewicht_avg);
        }
        if (snap) {
            this.einkaufPreisCtrl.setValue(snap.einkaufPreis, { emitEvent: false });
            this.verkaufPreisCtrl.setValue(snap.verkaufPreis, { emitEvent: false });
            this.einstallGewichtCtrl.setValue(snap.einstallGewicht, { emitEvent: false });
            this.abgangGewichtCtrl.setValue(snap.abgangGewicht, { emitEvent: false });
            this.einkaufMwstCtrl.setValue(snap.einkaufMwst, { emitEvent: false });
            this.verkaufMwstCtrl.setValue(snap.verkaufMwst, { emitEvent: false });
        } else if (this.isAusstallen) {
            this.abgangGewichtCtrl.setValue(null, { emitEvent: false });
            this.prefillGewichtFromMetric(this.row.abgangsgewicht_avg, this.abgangGewichtCtrl);
            this.prefillGewichtFromMetric(this.row.einstallgewicht_avg, this.einstallGewichtCtrl);
            this.prefillPreisFromMetric(this.row.verkaufspreis_avg, this.verkaufPreisCtrl);
            this.prefillPreisFromMetric(this.row.einkaufspreis_avg, this.einkaufPreisCtrl);
        } else {
            this.prefillGewichtFromMetric(this.row.einstallgewicht_avg, this.einstallGewichtCtrl);
            this.prefillPreisFromMetric(this.row.einkaufspreis_avg, this.einkaufPreisCtrl);
        }
        for (const focus of [
            'einstall-preis',
            'abgang-preis',
            'einstall-gewicht',
            'abgang-gewicht',
        ] as const) {
            this.syncProTierCtrlFromGesamt(focus);
            this.metricEntryMode[focus] = 'gesamt';
        }
        this.pendingOverwriteFields = [];
        this.pendingOverwriteAnimals = [];
        this.pendingOverwriteMode = 'empty_only';
        this.initialMetricSaveFingerprint = this.buildMetricSaveFingerprint();
    }

    private buildMetricSaveFingerprint(): string {
        const snap: Record<string, number> = {};
        if (this.isAusstallen) {
            this.addMetricFieldsToFingerprint(snap, this.buildAusstallAbgangPayload());
            this.addMetricFieldsToFingerprint(snap, this.buildAusstallEinstallOnTierlistePayload(), 'ausstall_');
        } else {
            this.addMetricFieldsToFingerprint(snap, this.buildDirectEinstallPayload());
        }
        return JSON.stringify(snap);
    }

    private addMetricFieldsToFingerprint(
        snap: Record<string, number>,
        payload: Record<string, unknown> | null,
        prefix = '',
    ): void {
        if (!payload) {
            return;
        }
        const fields = [
            'einstallgewicht',
            'abgangsgewicht',
            'kp_einstallpreis',
            'kp_abgangspreis',
            'kp_einstallmwstsatz',
            'kp_abgangsmwstsatz',
        ] as const;
        for (const field of fields) {
            const value = payload[field];
            if (value != null && !Number.isNaN(Number(value))) {
                snap[`${prefix}${field}`] = Number(value);
            }
        }
    }

    private hasGewichtPreisChanges(): boolean {
        if (!this.canEditGewichtPreis) {
            return false;
        }
        if (this.editingMetric) {
            this.finalizeMetricGesamtFromEntryMode(this.editingMetric);
        }
        return this.buildMetricSaveFingerprint() !== this.initialMetricSaveFingerprint;
    }

    private persistGewichtPreisMetrics(): Promise<void> {
        if (this.isAusstallen) {
            return this.saveAusstallenMetrics();
        }
        return this.saveEinstallGewichtPreis();
    }

    private applyMetricSaveSuccess(): void {
        this.commitAllMetricControlsToRow();
        this.patchRowPriceMetricsAfterSave();
        this.patchRowGewichtMetricsAfterSave();
        this.editingMetric = null;
        this.captureInitialMetricSaveFingerprint();
    }

    private runActionAfterPendingMetricsSave(action: () => void): void {
        void this.persistPendingMetricsBeforeAction().then(ok => {
            if (ok) {
                action();
            }
        });
    }

    /** Persist unsaved weight/price and tierliste meta edits before another dialog action runs. */
    private persistPendingMetricsBeforeAction(): Promise<boolean> {
        if (this.isSaving || this.isLoading) {
            return Promise.resolve(false);
        }

        this.finalizeActiveMetricEditing();

        const hadTierlisteMetaChanges = this.canEditTierlisteMeta && this.tierlisteMetaChanged();
        const hadMetricChanges = this.canEditGewichtPreis && this.hasGewichtPreisChanges();
        if (!hadTierlisteMetaChanges && !hadMetricChanges) {
            return Promise.resolve(true);
        }

        if (hadTierlisteMetaChanges && !this.tierliste) {
            this.messageService.alertMessage('Tierliste konnte nicht geladen werden.');
            return Promise.resolve(false);
        }

        if (hadMetricChanges && !this.validateMwstBeforeSave()) {
            return Promise.resolve(false);
        }

        const runSave = (): Promise<boolean> => {
            const saveSteps: Array<() => Promise<void>> = [];
            if (hadTierlisteMetaChanges) {
                saveSteps.push(() => this.saveTierlisteMeta());
            }
            if (hadMetricChanges) {
                saveSteps.push(() => this.persistGewichtPreisMetrics());
            }

            this.isSaving = true;
            return this.runSaveStepsSequentially(saveSteps)
                .then(() => {
                    if (hadMetricChanges) {
                        this.applyMetricSaveSuccess();
                    }
                    if (this.row.tierliste_id) {
                        this.tierlisteCache.invalidate(this.row.tierliste_id);
                    }
                    return true;
                })
                .catch(err => {
                    this.messageService.errorMessage('Fehler beim Speichern', err);
                    return false;
                })
                .finally(() => {
                    this.isSaving = false;
                });
        };

        if (!hadMetricChanges) {
            return runSave();
        }

        return this.resolveOverwriteModeBeforeSave().then(mode => {
            if (mode == null) {
                this.restoreMetricsAfterOverwriteCancel();
                return false;
            }
            this.pendingOverwriteMode = mode;
            return runSave();
        });
    }

    private prefillGewichtFromTotalOrMetric(
        tierlisteTotal: number | null | undefined,
        metric: LetzteAktionWertAnzahl | null | undefined,
        gesamtCtrl: FormControl<number | null>,
    ): void {
        if (tierlisteTotal != null && tierlisteTotal > 0) {
            gesamtCtrl.setValue(tierlisteTotal, { emitEvent: false });
            return;
        }
        this.prefillGewichtFromMetric(metric, gesamtCtrl);
    }

    private prefillGewichtFromMetric(
        metric: LetzteAktionWertAnzahl | null | undefined,
        gesamtCtrl: FormControl<number | null>,
    ): void {
        const gesamt = getLetzteAktionGewichtGesamt(metric);
        if (gesamt == null) {
            return;
        }
        gesamtCtrl.setValue(gesamt, { emitEvent: false });
    }

    private captureInitialZielbetriebState(): void {
        this.initialSchlachthofKundeId = Number(this.schlachthof?.kunde_id) || null;
        this.initialKundeIdEinstallen = Number(this.tierliste?.kunde_id_einstallen) || null;
        this.initialKundeIdZielbetrieb = Number(this.tierliste?.kunde_id_zielbetrieb) || null;
        this.initialKontaktIds = this.empfaengerKontakte
            .map(k => k.kontakt_id)
            .filter((id): id is number => id != null && id > 0);
    }

    private syncRowHerkunftFromEmpfaenger(): void {
        this.row.herkunft = getExternEmpfaengerDisplayLines(
            this.tierliste,
            this.empfaengerKontakte,
            this.schlachthof,
        ).join(', ');
    }

    private loadExternEmpfaenger(): void {
        if (!this.tierliste) {
            this.rebuildZielbetriebDisplayEntries();
            return;
        }
        this.initialSchlachthofKundeId = Number(this.tierliste.kunde_id_schlachthof) || null;
        this.initialKundeIdEinstallen = Number(this.tierliste.kunde_id_einstallen) || null;
        this.initialKundeIdZielbetrieb = Number(this.tierliste.kunde_id_zielbetrieb) || null;

        if (this.tierliste.kunde_id_schlachthof) {
            this.schlachthof = new Client();
            this.schlachthof.kunde_id = this.tierliste.kunde_id_schlachthof;
            this.schlachthof.bezeichnung = this.tierliste.kunde_schlachthof;
            this.schlachthof.zusatz = this.tierliste.kunde_zusatz_schlachthof;
            this.schlachthof.vvvo = this.tierliste.kunde_vvvo_schlachthof;
            this.schlachthof.strasse = this.tierliste.kunde_strasse_schlachthof;
            this.schlachthof.plz = this.tierliste.kunde_plz_schlachthof;
            this.schlachthof.ort = this.tierliste.kunde_ort_schlachthof;
        } else {
            this.schlachthof = null;
        }

        const tierlisteId = this.tierliste.tierliste_id;
        this.rebuildZielbetriebDisplayEntries();
        if (!tierlisteId) {
            this.captureInitialZielbetriebState();
            return;
        }

        this.subscriptions.add(
            this.bbtService.getVerbindungenFuerTierliste(tierlisteId).subscribe({
                next: result => {
                    const aktive = filterAktiveBetriebskontakteTierlisteVerbindungen(
                        unwrapBetriebskontakteTierlisteReadResponse(result),
                    );
                    this.empfaengerKontakte = mapBetriebskontakteTierlisteVerbindungenToKontakte(aktive);
                    this.captureInitialZielbetriebState();
                    this.rebuildZielbetriebDisplayEntries();
                },
                error: () => {
                    this.empfaengerKontakte = [];
                    this.captureInitialZielbetriebState();
                    this.rebuildZielbetriebDisplayEntries();
                },
            }),
        );
    }

    private loadZielbetriebClient(): void {
        const kundeId =
            Number(this.tierliste?.kunde_id_einstallen) ||
            Number(this.tierliste?.kunde_id_zielbetrieb) ||
            0;
        if (kundeId <= 0) {
            this.rebuildZielbetriebDisplayEntries();
            return;
        }
        this.initialZielKundeId = kundeId;
        const params = new HttpParams().set('kunde_id', String(kundeId));
        this.subscriptions.add(
            this.api.get(this.apiBaseUrl + 'kunde/read_one_kundenportal.php', params).subscribe({
                next: (kunde: Client) => {
                    if (kunde) {
                        this.zielbetrieb = kunde;
                    }
                    this.rebuildZielbetriebDisplayEntries();
                },
                error: () => {
                    /* display falls back to tierliste / row label */
                    this.rebuildZielbetriebDisplayEntries();
                },
            }),
        );
    }

    get canShowTiereSection(): boolean {
        return !!this.buildTiereApiRequest();
    }

    get canEditHerkunft(): boolean {
        return (
            this.isEinstallen &&
            this.canShowTiereSection &&
            this.localStorageService.hasPermission(PERMISSION_HERKUNFT) &&
            !this.showImportClosedHint &&
            canEditHerkunftForLetzteAktionRow(this.row, this.tierliste)
        );
    }

    /** Same guard as Herkunft — one edit dialog for both fields. */
    get canEditHandler(): boolean {
        return this.canEditHerkunft;
    }

    get displayHandlerLabel(): string {
        const fromTierliste = (this.tierliste?.viehhaendler_name || '').trim();
        if (fromTierliste) {
            return fromTierliste;
        }
        return (this.row.handler || '').trim();
    }

    get displayHerkunftLabel(): string {
        return (this.row.herkunft || '').trim();
    }

    get displayHerkunftCardValue(): string {
        const label = getLetzteAktionHerkunftZielDisplay({
            aktion: this.row.aktion,
            herkunft: this.displayHerkunftLabel || this.row.herkunft,
            handler: this.displayHandlerLabel || this.row.handler,
        });
        if (label !== '—') {
            return label;
        }
        return this.canEditHerkunft ? 'Noch nicht gesetzt' : '—';
    }

    /** Erstellt Einstallen: Tiere der Liste in eine andere Gruppe verschieben (wie /gruppen/aktuelle). */
    get showGruppeOverview(): boolean {
        return shouldShowAktuelleGruppeForRow(this.row, this.tierliste);
    }

    get showAbschnittOverview(): boolean {
        return shouldShowAbschnittForLetzteAktionRow(this.row, this.tierliste);
    }

    /** Import · Erstellt: reduced overview (no Gruppe/Abschnitt/Metriken). */
    get isPendingImportOverview(): boolean {
        return isPendingImportEinstallRow(this.row, this.tierliste);
    }

    getAbschnittDisplay(): string {
        return getLetzteAktionAbschnittDisplay(this.row, this.tierliste);
    }

    /** Gruppen-Ausstallliste im Dashboard nachträglich für alle Gruppen des Betriebs öffnen. */
    get canMakeAusstalllisteGlobal(): boolean {
        if (!this.isAusstallen || this.isSaving || !this.tierliste?.tierliste_id) {
            return false;
        }
        if (isGlobalAusstallTierliste(this.tierliste, this.row)) {
            return false;
        }
        const statusId = Number(this.tierliste.status_id ?? this.row.listenstatus_id ?? this.row.status_id_anzeige ?? 0);
        return statusId === 161 || statusId === 162;
    }

    makeAusstalllisteGlobal(event?: Event): void {
        event?.stopPropagation();
        if (!this.canMakeAusstalllisteGlobal || !this.tierliste) {
            return;
        }
        const input = new ConfirmDialogInput();
        input.headline = 'Globale Ausstallliste';
        input.text =
            'Die Liste ist danach nicht mehr an diese Gruppe gebunden. Tiere aus allen Gruppen dieses Betriebs können hinzugefügt werden. Die Tiere auf der Liste bleiben.';
        input.okButton = 'Zur globalen Liste';
        this.dialog
            .open(ConfirmDialogComponent, { width: '420px', maxWidth: '95vw', data: input })
            .afterClosed()
            .subscribe({
                next: (result: ConfirmDialogResult) => {
                    if (result?.confirmed) {
                        this.persistAusstalllisteGlobal();
                    }
                },
            });
    }

    private persistAusstalllisteGlobal(): void {
        if (!this.tierliste?.tierliste_id) {
            return;
        }
        const payload = this.kommentarNurWennGeaendert({ ...this.tierliste });
        payload.mehrere_gruppen = 1;
        payload.status_id = this.statusIdForOverviewSave(payload.status_id);
        this.isSaving = true;
        this.postTierlisteUpdate(payload)
            .then(liste => {
                this.tierliste = {
                    ...this.tierliste,
                    ...liste,
                    mehrere_gruppen: 1,
                    gruppe_id_abgang: null as unknown as number,
                };
                this.row.aktuelle_gruppe = 'Global';
                this.row.gruppe_id = null;
                this.row.gruppen = [];
                this.gruppeLinks = [];
                if (this.row.tierliste_id) {
                    this.tierlisteCache.invalidate(this.row.tierliste_id);
                }
                this.data.onRowChanged?.();
                this.messageService.infoMessage('Die Ausstallliste gilt jetzt für alle Gruppen dieses Betriebs.');
            })
            .catch(err => {
                this.messageService.errorMessage('Die Liste konnte nicht auf global umgestellt werden.', err);
            })
            .finally(() => {
                this.isSaving = false;
            });
    }

    get canEditGruppe(): boolean {
        return (
            this.showGruppeOverview &&
            this.isEinstallen &&
            getLetzteAktionenStatusPhase(this.row) === 'erstellt' &&
            this.canShowTiereSection &&
            this.localStorageService.hasPermission(PERMISSION_GRUPPE_AENDERN) &&
            !this.showImportClosedHint &&
            !isPendingImportEinstallRow(this.row, this.tierliste)
        );
    }

    openGruppeAendern(event?: Event): void {
        if (!this.canEditGruppe || this.tiereLoading) {
            return;
        }
        if (event instanceof KeyboardEvent && event.key === ' ') {
            event.preventDefault();
        }
        event?.stopPropagation();

        this.loadTiereList(() => {
            if (!this.tiereList.length) {
                this.messageService.alertMessage('Keine Tiere in dieser Tierliste gefunden.');
                return;
            }
            const gruppeId = this.resolveGruppeIdForTiereApi() ?? this.primaryGruppeId;
            if (!gruppeId) {
                this.messageService.alertMessage('Keine Gruppe für diese Aktion gefunden.');
                return;
            }
            const gruppeTiere = this.tiereList.map(tier => this.toGruppeTier(tier, gruppeId));
            const einstallTierlisteId = this.resolveEinstallTierlisteIdForGruppeAendern();
            const dashboardSync: GruppeAendernDashboardSync = {
                gda_id: Number(this.row.aktion_id) || undefined,
                kunde_id: this.gruppeKundeId ?? undefined,
                tierliste_id: einstallTierlisteId ?? (Number(this.row.tierliste_id) || undefined),
                einstall_tierliste_id: einstallTierlisteId ?? undefined,
            };
            this.gruppeTierService.openGruppeAuswaehlenDialog(gruppeTiere, dashboardSync).subscribe({
                next: neueGruppe => {
                    if (!neueGruppe?.gruppe_id) {
                        return;
                    }
                    this.applyGruppeAendernSuccess(neueGruppe);
                },
            });
        });
    }

    private applyGruppeAendernSuccess(neueGruppe: Gruppe): void {
        this.row.gruppe_id = neueGruppe.gruppe_id;
        this.row.aktuelle_gruppe = neueGruppe.bezeichnung ?? this.row.aktuelle_gruppe;
        this.row.gruppen = [
            {
                gruppe_id: neueGruppe.gruppe_id,
                bezeichnung: neueGruppe.bezeichnung ?? '',
            },
        ];
        this.gruppeLinks = [...this.row.gruppen];
        this.gruppeStandort = this.buildGruppeStandort(neueGruppe);
        if (this.tierliste) {
            this.tierliste.gruppe_id_einstallen = neueGruppe.gruppe_id;
        }
        const einstallTid = getEinstallTierlisteIdForRow(this.row, this.tierliste);
        if (einstallTid) {
            this.tierlisteCache.invalidate(einstallTid);
        }
        if (this.row.tierliste_id) {
            this.tierlisteCache.invalidate(this.row.tierliste_id);
        }
        this.loadTiereList();
        this.data.onRowChanged?.();
        this.messageService.infoMessage('Gruppe wurde für alle Tiere in der Liste geändert.');
    }

    openTiereModal(): void {
        if (this.tiereLoading) {
            return;
        }
        this.loadTiereList(() => this.openTiereListDialog());
    }

    onOpenTiereModalActivate(event?: Event): void {
        if (this.tiereLoading || !this.canShowTiereSection) {
            return;
        }
        if (event instanceof KeyboardEvent && event.key === ' ') {
            event.preventDefault();
        }
        event?.stopPropagation();
        this.openTiereModal();
    }

    loadTiereList(afterLoad?: (records: LetzteAktionTierListItem[]) => void): void {
        const request = this.buildTiereApiRequest();
        if (!request || this.tiereLoading) {
            return;
        }

        this.tiereLoading = true;

        this.subscriptions.add(
            this.fetchTiereRecords$().subscribe({
                next: records => {
                    this.applyLoadedTiereList(records);
                    afterLoad?.(records);
                },
                error: err => {
                    this.tiereLoading = false;
                    this.messageService.errorMessage('Tiere konnten nicht geladen werden', err);
                },
            }),
        );
    }

    openHerkunftSetzen(event?: Event): void {
        event?.stopPropagation();
        if (!this.canEditHerkunft || this.tiereLoading) {
            return;
        }

        const sourceTierlisteId =
            getEinstallTierlisteIdForRow(this.row, this.tierliste) ||
            Number(this.row.tierliste_id) ||
            Number(this.tierliste?.tierliste_id) ||
            0;
        const ausstallTierlisteId = resolveAusstallTierlisteIdForHerkunft(sourceTierlisteId, this.tierliste);
        if (ausstallTierlisteId <= 0) {
            this.messageService.alertMessage('Keine Tierliste für diese Aktion gefunden.');
            return;
        }

        this.loadTiereList(() => {
            const gruppeId = this.resolveGruppeIdForTiereApi() ?? this.primaryGruppeId;
            const gruppeTiere = this.tiereList.map(tier => this.toGruppeTier(tier, gruppeId ?? undefined));
            this.openTierlisteHerkunftDialog(ausstallTierlisteId, gruppeTiere, gruppeId ?? undefined);
        });
    }

    private applyHandlerUpdateSuccess(label: string): void {
        const trimmed = (label || '').trim();
        this.row.handler = trimmed || null;
        if (this.tierliste) {
            this.tierliste.viehhaendler_name = trimmed || undefined;
            if (!trimmed) {
                this.tierliste.viehhaendler_id = null as unknown as number;
            }
        }
        this.loadTiereList();
        this.tierlisteCache.invalidate(Number(this.row.tierliste_id) || 0);
        const einstallTid = getEinstallTierlisteIdForRow(this.row, this.tierliste);
        if (einstallTid) {
            this.tierlisteCache.invalidate(einstallTid);
        }
    }

    /** In-place list update — no full read_letzte_aktionen reload for Herkunft/Händler. */
    private notifyRowOriginPatched(): void {
        this.data.onRowChanged?.({ reload: false });
    }

    private openTiereListDialog(): void {
        this.dialog
            .open(LetzteAktionenTiereDialogComponent, {
                width: '520px',
                maxWidth: '96vw',
                maxHeight: '85vh',
                autoFocus: false,
                data: {
                    tiere: this.tiereList,
                    reload: () => this.fetchTiereRecords$(),
                },
            })
            .afterClosed()
            .subscribe({
                next: result => {
                    if (result?.tiere) {
                        this.applyLoadedTiereList(result.tiere);
                    }
                },
            });
    }

    private fetchTiereRecords$(): Observable<LetzteAktionTierListItem[]> {
        const request = this.buildTiereApiRequest();
        if (!request) {
            return of([]);
        }
        return this.api.getAll(request.url, request.params).pipe(
            map(response => (response?.records ?? []) as LetzteAktionTierListItem[]),
        );
    }

    private openTierlisteHerkunftDialog(tierlisteId: number, tiere: GruppeTier[], gruppeId?: number): void {
        this.dialog
            .open(DashboardTierlisteHerkunftSetzenDialogComponent, {
                width: '98vw',
                maxWidth: '920px',
                panelClass: 'herkunft-setzen-dialog-panel',
                data: {
                    tierliste_id: tierlisteId,
                    tiere,
                    gruppeId,
                    viehhaendler_id: this.tierliste?.viehhaendler_id ?? null,
                },
            })
            .afterClosed()
            .subscribe({
                next: (result: DashboardTierlisteHerkunftSetzenDialogResult | false | undefined) => {
                    if (result === false || result === undefined) {
                        return;
                    }
                    let originPatched = false;
                    if (Object.prototype.hasOwnProperty.call(result, 'herkunft')) {
                        const trimmed = (result.herkunft ?? '').trim();
                        this.row.herkunft = trimmed || '—';
                        originPatched = true;
                    }
                    if (Object.prototype.hasOwnProperty.call(result, 'handler')) {
                        this.applyHandlerUpdateSuccess(result.handler ?? '');
                        originPatched = true;
                    }
                    if (originPatched) {
                        this.notifyRowOriginPatched();
                    }
                },
            });
    }

    /** Einstallen: animals are on gt.einstall_tierliste_id; gda.tierliste_id uses the same id. */
    private resolveEinstallTierlisteIdForGruppeAendern(): number | null {
        const fromRow = getEinstallTierlisteIdForRow(this.row, this.tierliste);
        if (fromRow) {
            return fromRow;
        }
        if (this.row.aktion === this.einstallenAktion && Number(this.row.tierliste_id) > 0) {
            return Number(this.row.tierliste_id);
        }
        return null;
    }

    private toGruppeTier(tier: LetzteAktionTierListItem, gruppeId?: number): GruppeTier {
        const gt = new GruppeTier();
        gt.gt_id = tier.gt_id;
        const gid = Number(gruppeId ?? this.primaryGruppeId ?? 0);
        if (gid > 0) {
            gt.gruppe_id = gid;
        }
        gt.herkunft_betrieb = tier.herkunft_betrieb ?? '';
        gt.herkunft_vvvo = tier.herkunft_vvvo ?? '';
        gt.herkunft_strasse = tier.herkunft_strasse ?? '';
        gt.herkunft_plz = tier.herkunft_plz ?? '';
        gt.herkunft_ort = tier.herkunft_ort ?? '';
        gt.herkunft_ortsteil = tier.herkunft_ortsteil ?? '';
        return gt;
    }

    private applyLoadedTiereList(records: LetzteAktionTierListItem[]): void {
        this.tiereList = records;
        this.tiereLoading = false;
        this.anzahlTiere = records.length;
    }

    /** Sync animal count from tierliste (same query as „Tiere anzeigen“). */
    private refreshAnzahlTiereFromListe(): void {
        if (isGlobalAusstallTierliste(this.tierliste, this.row)) {
            return;
        }
        const request = this.buildTiereApiRequest();
        if (!request) {
            return;
        }
        this.subscriptions.add(
            this.api.getAll(request.url, request.params).subscribe({
                next: response => {
                    const records = (response?.records ?? []) as LetzteAktionTierListItem[];
                    const liveCount = records.length;
                    if (liveCount > 0) {
                        this.anzahlTiere = liveCount;
                    }
                    if (this.isEinstallen && records.length > 0) {
                        this.tiereList = records;
                    }
                },
                error: () => {
                    /* keep prefill count */
                },
            }),
        );
    }

    /** After Umstallen import, animals sit on the child Einstall-liste, not gt.tierliste_id. */
    private resolveLinkedEinstallTierlisteId(
        tierliste: Tierliste | null,
        gruppeId: number | null | undefined,
    ): Observable<number | null> {
        if (!this.isAusstallen || !tierliste?.tierliste_id || !gruppeId) {
            return of(null);
        }
        if (getLetzteAktionenStatusPhase(this.row) !== 'abgeschlossen') {
            return of(null);
        }
        const params = new HttpParams()
            .set('tierliste_id', String(tierliste.tierliste_id))
            .set('gruppe_id', String(gruppeId));
        return this.api.get(this.apiBaseUrl + 'gruppe/read_resolve_einstall_tierliste.php', params).pipe(
            map((res: { einstall_tierliste_id?: number | null }) => {
                const id = Number(res?.einstall_tierliste_id) || 0;
                return id > 0 ? id : null;
            }),
            catchError(() => of(null)),
        );
    }

    private buildEinstallTierlisteTiereParams(einstallTierlisteId: number, gruppeId: number): HttpParams {
        return new HttpParams()
            .set('einstall_tierliste_id', String(einstallTierlisteId))
            .set('gruppe_id', String(gruppeId))
            .set('for_continue_scan', '1');
    }

    /** Permission anchor for Tiere API; Zielgruppe optional before import. */
    private resolveGruppeIdForTiereApi(): number | null {
        const fromStandort = Number(this.gruppeStandort?.gruppe_id) || 0;
        if (fromStandort > 0) {
            return fromStandort;
        }
        const fromRow = Number(this.row.gruppe_id) || 0;
        if (fromRow > 0) {
            return fromRow;
        }
        const links = getGruppeLinksForRow(this.row);
        return links.length > 0 ? links[0].gruppe_id : null;
    }

    private buildTiereApiRequest(): { url: string; params: HttpParams } | null {
        const einstallTid =
            (getEinstallTierlisteIdForRow(this.row, this.tierliste) ?? Number(this.tierliste?.tierliste_id)) || 0;

        const ausstallTid = getAusstallTierlisteIdForImportRow(this.row, this.tierliste);
        if (isPendingImportEinstallRow(this.row, this.tierliste) && ausstallTid) {
            let params = new HttpParams()
                .set('tierliste_id', String(ausstallTid))
                .set('tierliste_gesamt', '1');
            const permissionGruppeId = this.resolveGruppeIdForTiereApi();
            if (permissionGruppeId) {
                params = params.set('gruppe_id', String(permissionGruppeId));
            }
            return {
                url: this.apiBaseUrl + 'gruppe/read_tiere_fuer_letzte_aktion.php',
                params,
            };
        }

        if (
            this.tierliste?.tierliste_id &&
            this.isAusstallen &&
            isGlobalAusstallTierliste(this.tierliste, this.row)
        ) {
            let params = new HttpParams()
                .set('tierliste_id', String(this.tierliste.tierliste_id))
                .set('tierliste_gesamt', '1');
            const permissionGruppeId = this.resolveGruppeIdForTiereApi();
            if (permissionGruppeId) {
                params = params.set('gruppe_id', String(permissionGruppeId));
            }
            return {
                url: this.apiBaseUrl + 'gruppe/read_tiere_fuer_letzte_aktion.php',
                params,
            };
        }

        const gruppeId = this.resolveGruppeIdForTiereApi();
        if (!gruppeId) {
            return null;
        }
        const gruppeIdStr = String(gruppeId);
        if (isImportedEinstallAbgeschlossen(this.row, this.tierliste) && einstallTid > 0) {
            return {
                url: this.apiBaseUrl + 'gruppe/read_tiere_fuer_letzte_aktion.php',
                params: this.buildEinstallTierlisteTiereParams(einstallTid, gruppeId),
            };
        }
        if (this.row.aktion === TierLetzteAktionTyp.einstallen && einstallTid > 0) {
            return {
                url: this.apiBaseUrl + 'gruppe/read_tiere_fuer_letzte_aktion.php',
                params: this.buildEinstallTierlisteTiereParams(einstallTid, gruppeId),
            };
        }
        if (this.tierliste?.tierliste_id && this.isAusstallen) {
            const linkedEinstall = Number(this.linkedEinstallTierlisteId) || 0;
            if (linkedEinstall > 0 && getLetzteAktionenStatusPhase(this.row) === 'abgeschlossen') {
                return {
                    url: this.apiBaseUrl + 'gruppe/read_tiere_fuer_letzte_aktion.php',
                    params: this.buildEinstallTierlisteTiereParams(linkedEinstall, gruppeId),
                };
            }
            if (getGruppeLinksForRow(this.row).length > 1) {
                let params = new HttpParams()
                    .set('tierliste_id', String(this.tierliste.tierliste_id))
                    .set('tierliste_gesamt', '1');
                if (gruppeId) {
                    params = params.set('gruppe_id', gruppeIdStr);
                }
                return {
                    url: this.apiBaseUrl + 'gruppe/read_tiere_fuer_letzte_aktion.php',
                    params,
                };
            }
            return {
                url: this.apiBaseUrl + 'gruppe/read_tiere_fuer_letzte_aktion.php',
                params: new HttpParams()
                    .set('tierliste_id', String(this.tierliste.tierliste_id))
                    .set('gruppe_id', gruppeIdStr),
            };
        }
        return null;
    }

    private saveZielbetrieb(): Promise<void> {
        if (!this.tierliste) {
            return Promise.reject(new Error('Tierliste fehlt'));
        }

        if (this.isInternTransfer) {
            const kundeId = Number(this.zielbetrieb?.kunde_id);
            if (kundeId <= 0) {
                return Promise.reject(new Error('Zielbetrieb fehlt'));
            }
            const payload = this.kommentarNurWennGeaendert({ ...this.tierliste });
            payload.status_id = this.statusIdForOverviewSave(payload.status_id);
            payload.kunde_id_einstallen = kundeId;
            payload.kunde_id_zielbetrieb = kundeId;
            return this.postTierlisteUpdate(payload).then(liste => {
                this.tierliste = { ...this.tierliste, ...liste };
                this.initialZielKundeId = kundeId;
                if (this.zielbetrieb) {
                    this.applyInternZielbetriebSelection(this.zielbetrieb);
                }
                if (this.row.tierliste_id) {
                    this.refreshOpenAbgangModalTierliste(this.row.tierliste_id, this.tierliste);
                }
            });
        }

        const payload = this.kommentarNurWennGeaendert({ ...this.tierliste });
        payload.status_id = this.statusIdForOverviewSave(payload.status_id);
        applyExternEmpfaengerPersistFields(payload, this.empfaengerKontakte);
        applySchlachthofPersistField(payload, this.schlachthof);

        return new Promise((resolve, reject) => {
            this.postTierlisteUpdate(payload)
                .then(liste => {
                    const kontaktIds = this.empfaengerKontakte
                        .filter(k => k.kontakt_id)
                        .map(k => k.kontakt_id!);
                    this.bbtService
                        .updateKontakteFuerTierliste(kontaktIds, liste.tierliste_id, {
                            allowClearAll: kontaktIds.length === 0,
                        })
                        .subscribe({
                        next: () => {
                            this.tierliste = patchTierlisteFromExternEmpfaenger(
                                liste,
                                this.empfaengerKontakte,
                                this.schlachthof,
                            );
                            this.captureInitialZielbetriebState();
                            this.syncRowHerkunftFromEmpfaenger();
                            this.rebuildZielbetriebDisplayEntries();
                            if (this.row.tierliste_id) {
                                this.refreshOpenAbgangModalTierliste(this.row.tierliste_id, this.tierliste);
                            }
                            this.data.onRowChanged?.();
                            resolve();
                        },
                        error: err => reject(err),
                    });
                })
                .catch(err => reject(err));
        });
    }

    private postTierlisteUpdate(payload: Tierliste): Promise<Tierliste> {
        return new Promise((resolve, reject) => {
            this.api.post(this.apiBaseUrl + 'tierliste/update_kundenportal.php', payload, undefined).subscribe({
                next: (liste: Tierliste) => resolve(liste),
                error: err => reject(err),
            });
        });
    }

    private importTierlisteInVorhandeneGruppe(tierliste: Tierliste, kunde: Client): void {
        const input = new GruppeAuswaehlenDialogInput2();
        input.client = kunde;
        this.dialog
            .open<GruppeAuswaehlenDialogComponent, GruppeAuswaehlenDialogInput2, Gruppe>(
                GruppeAuswaehlenDialogComponent,
                { ...getGruppeAuswaehlenDialogShellConfig(), data: input },
            )
            .afterClosed()
            .subscribe({
                next: gruppe => {
                    if (gruppe) {
                        this.importTierlisteInGruppe(tierliste, gruppe);
                    }
                },
            });
    }

    private importTierlisteInGruppe(tierliste: Tierliste, gruppe: Gruppe): void {
        tierliste.gruppe_id_einstallen = gruppe.gruppe_id;
        tierliste.status_id = 163;
        const optionenDialog = this.dialog.open(ImportOptionenDialogComponent, {
            maxWidth: '600px',
            data: { tierliste },
        });
        optionenDialog.afterClosed().subscribe({
            next: updatedTierliste => {
                if (!updatedTierliste) {
                    this.dialogRef.close(true);
                    return;
                }
                this.isSaving = true;
                this.api.post(
                    this.apiBaseUrl + 'tierliste/update_kundenportal.php',
                    ohneTierlisteKommentar(updatedTierliste),
                    undefined,
                ).subscribe({
                    next: () => {
                        const importedTierlisteId = Number(updatedTierliste?.tierliste_id || tierliste?.tierliste_id || 0);
                        void this.persistImportedEinstallgewichte(updatedTierliste).finally(() => {
                            this.isSaving = false;
                            this.appService.setBlockOnLoading(false);
                            this.messageService.infoMessage('Die Tiere wurden erfolgreich der Gruppe hinzugefügt!');
                            this.gruppenDashboardImportRefresh.notifyImportCompleted(importedTierlisteId);
                            this.dialogRef.close(true);
                        });
                    },
                    error: err => {
                        this.isSaving = false;
                        this.appService.setBlockOnLoading(false);
                        this.messageService.errorMessage('Fehler!', err);
                    },
                });
            },
        });
    }

    private async persistImportedEinstallgewichte(tierliste: Tierliste): Promise<void> {
        const records = (tierliste as any)?.import_einstallgewichte_records || [];
        const gruppeId = Number(tierliste?.gruppe_id_einstallen);
        if (!records.length || gruppeId <= 0) {
            return;
        }
        try {
            await this.api
                .post(this.apiBaseUrl + 'gruppe_standort/save_einstallgewichte.php', {
                    gs_id: 0,
                    gruppe_id: gruppeId,
                    tierliste_id: Number(tierliste?.tierliste_id || 0),
                    records,
                })
                .toPromise();
        } catch (error) {
            this.messageService.errorMessage(
                'Import erfolgreich, aber Einstallgewichte konnten nicht vollstaendig gespeichert werden!',
                error,
            );
        }
    }

    private prefillPreisFromMetric(
        metric: LetzteAktionWertAnzahl | null | undefined,
        gesamtCtrl: FormControl<number | null>,
    ): void {
        const gesamt = getLetzteAktionPreisGesamt(metric);
        if (gesamt == null) {
            return;
        }
        gesamtCtrl.setValue(gesamt, { emitEvent: false });
    }

    private wireMetricDualFieldSync(): void {
        const pairs: Array<[LetzteAktionenMetricEditFocus, FormControl<number | null>, FormControl<number | null>]> =
            [
                ['einstall-preis', this.einkaufPreisProTierCtrl, this.einkaufPreisCtrl],
                ['abgang-preis', this.verkaufPreisProTierCtrl, this.verkaufPreisCtrl],
                ['einstall-gewicht', this.einstallGewichtProTierCtrl, this.einstallGewichtCtrl],
                ['abgang-gewicht', this.abgangGewichtProTierCtrl, this.abgangGewichtCtrl],
            ];
        for (const [focus, proCtrl, gesamtCtrl] of pairs) {
            this.subscriptions.add(
                proCtrl.valueChanges.subscribe(val => {
                    if (this.getMetricEntryMode(focus) !== 'proTier' || this.editingMetric !== focus) {
                        return;
                    }
                    const anzahl = this.effectiveAnzahlTiere();
                    if (anzahl <= 0 || val == null || Number.isNaN(Number(val))) {
                        return;
                    }
                    gesamtCtrl.setValue(this.roundGesamtFromProTier(Number(val), anzahl), { emitEvent: false });
                }),
            );
            this.subscriptions.add(
                gesamtCtrl.valueChanges.subscribe(val => {
                    if (this.getMetricEntryMode(focus) !== 'gesamt' || this.editingMetric !== focus) {
                        return;
                    }
                    const anzahl = this.effectiveAnzahlTiere();
                    if (anzahl <= 0 || val == null || Number.isNaN(Number(val))) {
                        return;
                    }
                    proCtrl.setValue(this.roundProTierFromGesamt(Number(val), anzahl), { emitEvent: false });
                }),
            );
        }
    }

    private getMetricGesamtCtrl(focus: LetzteAktionenMetricEditFocus): FormControl<number | null> {
        switch (focus) {
            case 'einstall-preis':
                return this.einkaufPreisCtrl;
            case 'abgang-preis':
                return this.verkaufPreisCtrl;
            case 'einstall-gewicht':
                return this.einstallGewichtCtrl;
            case 'abgang-gewicht':
                return this.abgangGewichtCtrl;
        }
    }

    private getMetricProTierCtrl(focus: LetzteAktionenMetricEditFocus): FormControl<number | null> {
        switch (focus) {
            case 'einstall-preis':
                return this.einkaufPreisProTierCtrl;
            case 'abgang-preis':
                return this.verkaufPreisProTierCtrl;
            case 'einstall-gewicht':
                return this.einstallGewichtProTierCtrl;
            case 'abgang-gewicht':
                return this.abgangGewichtProTierCtrl;
        }
    }

    private getMergedMetricForFocus(focus: LetzteAktionenMetricEditFocus): LetzteAktionWertAnzahl | null {
        switch (focus) {
            case 'einstall-preis':
                return this.mergeMetricWithControl(this.einkaufPreisCtrl, this.row.einkaufspreis_avg);
            case 'abgang-preis':
                return this.mergeMetricWithControl(this.verkaufPreisCtrl, this.row.verkaufspreis_avg);
            case 'einstall-gewicht':
                return this.mergeMetricWithControl(this.einstallGewichtCtrl, this.row.einstallgewicht_avg);
            case 'abgang-gewicht':
                return this.mergeMetricWithControl(this.abgangGewichtCtrl, this.row.abgangsgewicht_avg);
        }
    }

    private syncProTierCtrlFromGesamt(focus: LetzteAktionenMetricEditFocus): void {
        const anzahl = this.effectiveAnzahlTiere();
        if (anzahl <= 0) {
            return;
        }
        const gesamt = Number(this.getMetricGesamtCtrl(focus).value);
        if (gesamt > 0 && !Number.isNaN(gesamt)) {
            this.getMetricProTierCtrl(focus).setValue(this.roundProTierFromGesamt(gesamt, anzahl), {
                emitEvent: false,
            });
        }
    }

    private roundGesamtFromProTier(pro: number, anzahl: number): number {
        return Math.round(pro * anzahl * 100) / 100;
    }

    private roundProTierFromGesamt(gesamt: number, anzahl: number): number {
        return Math.round((gesamt / anzahl) * 100) / 100;
    }

    private finalizeMetricGesamtFromEntryMode(focus: LetzteAktionenMetricEditFocus): void {
        if (this.getMetricEntryMode(focus) !== 'proTier') {
            return;
        }
        const anzahl = this.effectiveAnzahlTiere();
        const pro = Number(this.getMetricProTierCtrl(focus).value);
        if (anzahl <= 0 || pro <= 0 || Number.isNaN(pro)) {
            return;
        }
        this.getMetricGesamtCtrl(focus).setValue(this.roundGesamtFromProTier(pro, anzahl), { emitEvent: false });
    }

    private effectiveAnzahlTiere(): number {
        if (this.anzahlTiere > 0) {
            return this.anzahlTiere;
        }
        const rowCount = Number(this.row.anzahl_tiere) || 0;
        if (rowCount > 0) {
            return rowCount;
        }
        for (const metric of [
            this.row.abgangsgewicht_avg,
            this.row.einstallgewicht_avg,
            this.row.verkaufspreis_avg,
            this.row.einkaufspreis_avg,
        ]) {
            const fromMetric = Number(metric?.anzahl) || 0;
            if (fromMetric > 0) {
                return fromMetric;
            }
        }
        return 0;
    }

    private resolvePerTierFromGesamtValue(
        gesamt: number,
        rowMetric?: LetzteAktionWertAnzahl | null,
    ): number | undefined {
        if (gesamt <= 0) {
            return undefined;
        }
        const anzahl = this.effectiveAnzahlTiere() || Number(rowMetric?.anzahl) || 0;
        if (anzahl > 0) {
            return Math.round((gesamt / anzahl) * 100) / 100;
        }
        const proTier =
            getLetzteAktionGewichtProTier(rowMetric ?? null) ?? getLetzteAktionPreisProTier(rowMetric ?? null);
        return proTier != null && proTier > 0 ? proTier : undefined;
    }

    private mergeMetricWithControl(
        ctrl: FormControl<number | null>,
        rowMetric: LetzteAktionWertAnzahl | null | undefined,
    ): LetzteAktionWertAnzahl | null {
        const raw = ctrl.value;
        if (raw != null && !Number.isNaN(Number(raw))) {
            const anzahl = this.effectiveAnzahlTiere();
            return {
                wert: Number(raw),
                anzahl: anzahl > 0 ? anzahl : rowMetric?.anzahl ?? null,
            };
        }
        return rowMetric ?? null;
    }

    private commitMetricControlToRow(focus: LetzteAktionenMetricEditFocus): void {
        this.finalizeMetricGesamtFromEntryMode(focus);
        switch (focus) {
            case 'einstall-preis': {
                const metric = this.mergeMetricWithControl(this.einkaufPreisCtrl, this.row.einkaufspreis_avg);
                if (metric) {
                    this.row.einkaufspreis_avg = metric;
                }
                break;
            }
            case 'abgang-preis': {
                const metric = this.mergeMetricWithControl(this.verkaufPreisCtrl, this.row.verkaufspreis_avg);
                if (metric) {
                    this.row.verkaufspreis_avg = metric;
                }
                break;
            }
            case 'einstall-gewicht': {
                const metric = this.mergeMetricWithControl(this.einstallGewichtCtrl, this.row.einstallgewicht_avg);
                if (metric) {
                    this.row.einstallgewicht_avg = metric;
                }
                break;
            }
            case 'abgang-gewicht': {
                const metric = this.mergeMetricWithControl(this.abgangGewichtCtrl, this.row.abgangsgewicht_avg);
                if (metric) {
                    this.row.abgangsgewicht_avg = metric;
                }
                break;
            }
        }
    }

    private commitAllMetricControlsToRow(): void {
        this.commitMetricControlToRow('einstall-preis');
        this.commitMetricControlToRow('einstall-gewicht');
        if (this.isAusstallen) {
            this.commitMetricControlToRow('abgang-preis');
            this.commitMetricControlToRow('abgang-gewicht');
        }
    }

    private patchRowGewichtMetricsAfterSave(): void {
        if (!this.canShowGewicht) {
            return;
        }
        if (this.isAusstallen) {
            const abgang = this.mergeMetricWithControl(this.abgangGewichtCtrl, this.row.abgangsgewicht_avg);
            if (abgang) {
                this.row.abgangsgewicht_avg = abgang;
            }
            const einstall = this.mergeMetricWithControl(this.einstallGewichtCtrl, this.row.einstallgewicht_avg);
            if (einstall) {
                this.row.einstallgewicht_avg = einstall;
            }
        } else if (this.isEinstallen) {
            const einstall = this.mergeMetricWithControl(this.einstallGewichtCtrl, this.row.einstallgewicht_avg);
            if (einstall) {
                this.row.einstallgewicht_avg = einstall;
            }
        }
    }

    private patchRowPriceMetricsAfterSave(): void {
        if (!this.canShowPreis) {
            return;
        }
        if (this.isAusstallen) {
            const verkauf = this.mergeMetricWithControl(this.verkaufPreisCtrl, this.row.verkaufspreis_avg);
            if (verkauf) {
                this.row.verkaufspreis_avg = verkauf;
            }
            const einkauf = this.mergeMetricWithControl(this.einkaufPreisCtrl, this.row.einkaufspreis_avg);
            if (einkauf) {
                this.row.einkaufspreis_avg = einkauf;
            }
        } else {
            const einkauf = this.mergeMetricWithControl(this.einkaufPreisCtrl, this.row.einkaufspreis_avg);
            if (einkauf) {
                this.row.einkaufspreis_avg = einkauf;
            }
        }
    }

    /** `read_tiere_fuer_letzte_aktion` expects Y-m-d H:i:s (dashboard action timestamp). */
    private getLetzteAktionDatumForTiereApi(): string | null {
        const raw = (this.row.datum_raw || '').trim();
        if (raw.length >= 19 && /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}/.test(raw)) {
            return raw.slice(0, 19);
        }
        if (raw.length >= 10 && /^\d{4}-\d{2}-\d{2}/.test(raw)) {
            return `${raw.slice(0, 10)} 00:00:00`;
        }
        if (this.row.datum && !Number.isNaN(this.row.datum.getTime())) {
            const d = this.row.datum;
            const pad = (n: number) => String(n).padStart(2, '0');
            return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
        }
        return null;
    }

    /** Abgang/Verkauf and Einstall/Einkauf must run sequentially (MySQL deadlock). */
    private saveAusstallenMetrics(): Promise<void> {
        const abgangPayload = this.buildAusstallAbgangPayload();
        const einstallPayload = this.buildAusstallEinstallOnTierlistePayload();
        if (!abgangPayload && !einstallPayload) {
            return Promise.reject(
                new Error('Keine gültigen Gewicht- oder Preiswerte zum Speichern (Tiereanzahl prüfen).'),
            );
        }

        const steps: Array<() => Promise<void>> = [];
        if (abgangPayload) {
            steps.push(() =>
                this.postGewichtPreisPayload(
                    this.apiBaseUrl + 'gruppe_tier/update_ausstalldaten.php',
                    abgangPayload,
                ),
            );
        }
        if (einstallPayload) {
            steps.push(() =>
                this.postGewichtPreisPayload(
                    this.apiBaseUrl + 'gruppe_tier/update_einstalldaten.php',
                    einstallPayload,
                ),
            );
        }
        return this.runSaveStepsSequentially(steps);
    }

    private buildAusstallAbgangPayload(): Record<string, unknown> | null {
        if (!this.gruppeStandort?.gs_id || !this.tierliste?.tierliste_id) {
            return null;
        }

        const body: Record<string, unknown> = {
            gs_id: this.gruppeStandort.gs_id,
            gruppe_id: this.gruppeStandort.gruppe_id,
            tierliste_id: this.tierliste.tierliste_id,
            overwrite_mode: this.pendingOverwriteMode,
        };
        let hasField = false;

        if (this.canShowGewicht) {
            const gesamt = this.getGesamtFromMergedMetric(this.abgangGewichtCtrl, this.row.abgangsgewicht_avg);
            const perTier = this.resolveBulkFieldPerTier('abgangsgewicht', gesamt, this.row.abgangsgewicht_avg);
            if (perTier != null && perTier > 0) {
                body.abgangsgewicht = perTier;
                hasField = true;
            }
        }

        if (this.canShowPreis) {
            const gesamt = this.getGesamtFromMergedMetric(this.verkaufPreisCtrl, this.row.verkaufspreis_avg);
            const perTier = this.resolveBulkFieldPerTier('kp_abgangspreis', gesamt, this.row.verkaufspreis_avg);
            if (perTier != null && perTier > 0) {
                body.kp_abgangspreis = perTier;
                body.kp_abgangsmwstsatz = this.verkaufMwstCtrl.value ?? 7;
                hasField = true;
            }
        }

        return hasField ? body : null;
    }

    private buildAusstallEinstallOnTierlistePayload(): Record<string, unknown> | null {
        if (!this.gruppeStandort?.gs_id || !this.tierliste?.tierliste_id) {
            return null;
        }

        const body: Record<string, unknown> = {
            gs_id: this.gruppeStandort.gs_id,
            gruppe_id: this.gruppeStandort.gruppe_id,
            tierliste_id: this.tierliste.tierliste_id,
            overwrite_mode: this.pendingOverwriteMode,
        };
        let hasField = false;

        if (this.canShowGewicht) {
            const gesamt = this.getGesamtFromMergedMetric(this.einstallGewichtCtrl, this.row.einstallgewicht_avg);
            const perTier = this.resolveBulkFieldPerTier('einstallgewicht', gesamt, this.row.einstallgewicht_avg);
            if (perTier != null && perTier > 0) {
                body.einstallgewicht = perTier;
                hasField = true;
            }
        }

        if (this.canShowPreis) {
            const gesamt = this.getGesamtFromMergedMetric(this.einkaufPreisCtrl, this.row.einkaufspreis_avg);
            const perTier = this.resolveBulkFieldPerTier('kp_einstallpreis', gesamt, this.row.einkaufspreis_avg);
            if (perTier != null && perTier > 0) {
                body.kp_einstallpreis = perTier;
                body.kp_einstallmwstsatz = this.einkaufMwstCtrl.value ?? 7;
                hasField = true;
            }
        }

        return hasField ? body : null;
    }

    private saveEinstallGewichtPreis(): Promise<void> {
        const payload = this.buildDirectEinstallPayload();
        if (!payload) {
            return Promise.reject(
                new Error('Keine gültigen Gewicht- oder Preiswerte zum Speichern (Tiereanzahl prüfen).'),
            );
        }
        return this.postGewichtPreisPayload(
            this.apiBaseUrl + 'gruppe_tier/update_einstalldaten.php',
            payload,
        );
    }

    private buildDirectEinstallPayload(): Record<string, unknown> | null {
        if (!this.gruppeStandort?.gs_id) {
            return null;
        }

        const body: Record<string, unknown> = {
            gs_id: this.gruppeStandort.gs_id,
            gruppe_id: this.gruppeStandort.gruppe_id,
            overwrite_mode: this.pendingOverwriteMode,
        };
        const einstallTid = getEinstallTierlisteIdForRow(this.row, this.tierliste);
        if (einstallTid) {
            body.einstall_tierliste_id = einstallTid;
        } else {
            const einstallDay = this.getEinstallDatumYmd();
            if (!einstallDay) {
                return null;
            }
            body.einstalldatums = [einstallDay];
        }

        let hasField = false;
        if (this.canShowGewicht) {
            const gesamt = this.getGesamtFromMergedMetric(this.einstallGewichtCtrl, this.row.einstallgewicht_avg);
            const perTier = this.resolveBulkFieldPerTier('einstallgewicht', gesamt, this.row.einstallgewicht_avg);
            if (perTier != null && perTier > 0) {
                body.einstallgewicht = perTier;
                hasField = true;
            }
        }
        if (this.canShowPreis) {
            const gesamt = this.getGesamtFromMergedMetric(this.einkaufPreisCtrl, this.row.einkaufspreis_avg);
            const perTier = this.resolveBulkFieldPerTier('kp_einstallpreis', gesamt, this.row.einkaufspreis_avg);
            if (perTier != null && perTier > 0) {
                body.kp_einstallpreis = perTier;
                body.kp_einstallmwstsatz = this.einkaufMwstCtrl.value ?? 7;
                hasField = true;
            }
        }

        return hasField ? body : null;
    }

    private resolveBulkFieldPerTier(
        key: BulkOverwriteFieldKey,
        gesamt: number | null | undefined,
        rowMetric?: LetzteAktionWertAnzahl | null,
    ): number | undefined {
        const field =
            this.pendingOverwriteFields.find(f => f.key === key) ??
            this.buildBulkOverwriteFieldsBeingSaved().find(f => f.key === key);
        if (field && this.pendingOverwriteAnimals.length > 0) {
            const resolved = resolveBulkPerTierValue(
                this.pendingOverwriteMode,
                this.pendingOverwriteAnimals,
                field,
            );
            return resolved != null && resolved > 0 ? resolved : undefined;
        }
        return gesamt != null ? this.resolvePerTierFromGesamtValue(gesamt, rowMetric) : undefined;
    }

    private postGewichtPreisPayload(url: string, body: Record<string, unknown>): Promise<void> {
        return new Promise((resolve, reject) => {
            this.api.post(url, body).subscribe({
                next: () => resolve(),
                error: err => reject(err),
            });
        });
    }

    /** null = user cancelled. */
    private resolveOverwriteModeBeforeSave(): Promise<BulkOverwriteMode | null> {
        const fields = this.buildBulkOverwriteFieldsBeingSaved();
        if (!fields.length) {
            this.pendingOverwriteFields = [];
            this.pendingOverwriteAnimals = [];
            return Promise.resolve('empty_only');
        }

        return this.loadAnimalsForBulkOverwrite()
            .then(animals => {
                this.pendingOverwriteFields = fields;
                this.pendingOverwriteAnimals = animals;
                if (!needsBulkOverwriteConfirm(animals, fields)) {
                    return 'empty_only' as BulkOverwriteMode;
                }
                return new Promise<BulkOverwriteMode | null>(resolve => {
                    this.dialog
                        .open(GruppeTierBulkOverwriteDialogComponent, {
                            width: '640px',
                            maxWidth: '95vw',
                            disableClose: true,
                            data: { fields, animals },
                        })
                        .afterClosed()
                        .subscribe(result => {
                            resolve(result?.mode ?? null);
                        });
                });
            })
            .catch(err => {
                this.messageService.errorMessage('Tiere für die Prüfung konnten nicht geladen werden', err);
                return null;
            });
    }

    private buildBulkOverwriteFieldsBeingSaved(): BulkOverwriteFieldSpec[] {
        const fields: BulkOverwriteFieldSpec[] = [];
        const pushGewicht = (
            key: BulkOverwriteFieldKey,
            label: string,
            focus: LetzteAktionenMetricEditFocus,
            gesamtCtrl: FormControl<number | null>,
            proCtrl: FormControl<number | null>,
            rowMetric: LetzteAktionWertAnzahl | null | undefined,
        ) => {
            const gesamt = this.getGesamtFromMergedMetric(gesamtCtrl, rowMetric);
            if (gesamt == null || !(gesamt > 0)) {
                return;
            }
            const preferProTier = this.getMetricEntryMode(focus) === 'proTier';
            const proRaw = Number(proCtrl.value);
            const proTier =
                preferProTier && proRaw > 0
                    ? proRaw
                    : this.resolvePerTierFromGesamtValue(gesamt, rowMetric) ?? null;
            fields.push({
                key,
                label,
                gesamtValue: gesamt,
                proTierValue: proTier,
                preferProTier,
                unit: 'kg',
            });
        };
        const pushPreis = (
            key: BulkOverwriteFieldKey,
            label: string,
            focus: LetzteAktionenMetricEditFocus,
            gesamtCtrl: FormControl<number | null>,
            proCtrl: FormControl<number | null>,
            rowMetric: LetzteAktionWertAnzahl | null | undefined,
        ) => {
            const gesamt = this.getGesamtFromMergedMetric(gesamtCtrl, rowMetric);
            if (gesamt == null || !(gesamt > 0)) {
                return;
            }
            const preferProTier = this.getMetricEntryMode(focus) === 'proTier';
            const proRaw = Number(proCtrl.value);
            const proTier =
                preferProTier && proRaw > 0
                    ? proRaw
                    : this.resolvePerTierFromGesamtValue(gesamt, rowMetric) ?? null;
            fields.push({
                key,
                label,
                gesamtValue: gesamt,
                proTierValue: proTier,
                preferProTier,
                unit: '€',
            });
        };

        if (this.isAusstallen) {
            if (this.canShowGewicht) {
                pushGewicht(
                    'abgangsgewicht',
                    'Abgangsgewicht',
                    'abgang-gewicht',
                    this.abgangGewichtCtrl,
                    this.abgangGewichtProTierCtrl,
                    this.row.abgangsgewicht_avg,
                );
                pushGewicht(
                    'einstallgewicht',
                    'Einstallgewicht',
                    'einstall-gewicht',
                    this.einstallGewichtCtrl,
                    this.einstallGewichtProTierCtrl,
                    this.row.einstallgewicht_avg,
                );
            }
            if (this.canShowPreis) {
                pushPreis(
                    'kp_abgangspreis',
                    'Verkaufspreis',
                    'abgang-preis',
                    this.verkaufPreisCtrl,
                    this.verkaufPreisProTierCtrl,
                    this.row.verkaufspreis_avg,
                );
                pushPreis(
                    'kp_einstallpreis',
                    'Einkaufspreis',
                    'einstall-preis',
                    this.einkaufPreisCtrl,
                    this.einkaufPreisProTierCtrl,
                    this.row.einkaufspreis_avg,
                );
            }
            return fields;
        }

        if (this.canShowGewicht) {
            pushGewicht(
                'einstallgewicht',
                'Einstallgewicht',
                'einstall-gewicht',
                this.einstallGewichtCtrl,
                this.einstallGewichtProTierCtrl,
                this.row.einstallgewicht_avg,
            );
        }
        if (this.canShowPreis) {
            pushPreis(
                'kp_einstallpreis',
                'Einkaufspreis',
                'einstall-preis',
                this.einkaufPreisCtrl,
                this.einkaufPreisProTierCtrl,
                this.row.einkaufspreis_avg,
            );
        }
        return fields;
    }

    private loadAnimalsForBulkOverwrite(): Promise<BulkOverwriteAnimalRow[]> {
        return this.loadAnimalsForBulkOverwriteRaw().then(records => records.map(mapGruppeTierRecordToBulkRow));
    }
}
